// Common
(function() {
    window.c24.lp.ipssReforged = {
        bIsMobile: window.c24LpIsMobile || false,
        bIsApp: window.c24LpIsApp || false,
        bIsSeaPage: window.c24LpPageType === 'SEA-LP' || window.c24LpPageType === 'SEA-SL' || false,
        iTimeout: 6000,
        aApiDataResult: null,
        aNonContractsGrouped: null, // contains all data except type: 'contract'
        aContractsGrouped: null, // should contain only contracts with type: 'contract'
        aAppointmentsGrouped: null, // should contain only contracts with type: 'appointment'
        aStaticTilesGrouped: null, // should contain only infos about static tile
        aPromotionsGrouped: null, // should contain only infos about Promotions
        aProductSpecificTilesGrouped: null, // should contain only infos about product specific tiles,
        aConsultantsGrouped: null, // should contain only infos about consultants
        iconMap: {},
        defaultPriceUnit: 'euro',
        priceUnitMap: {
            'euro': '\u20ac',
            'percent': '\u0025',
        },
        periodMap: {
            'monthly': 'monatlich',
            'month': 'monatlich',
            'yearly': 'jährlich',
            'year': 'jährlich',
            'once': 'einmalig',
            'halfyearly': 'halbjährlich',
            'quarterly': 'quartalsweise',
            'firstyear': 'im 1. Jahr',
            'permonth': 'pro Monat',
        },
        timeWordingMap: {
            'offer': 'erstellt',
            'incompleteContract': 'begonnen',
            'contract': 'beantragt',
        },
        tagsRatingMap: {
            'good': {
                'text': 'Gut',
                'color': 'green',
            },
            'okay': {
                'text': 'Befriedigend',
                'color': 'yellow',
            },
            'bad': {
                'text': 'Unzureichend',
                'color': 'red',
            },
        },
        deleleAllTextMap: {
            'lastSearches': {
                'singular': 'Vergleich',
                'plural': 'Vergleiche',
            },
            'contract': {
                'singular': 'Vertrag',
                'plural': 'Verträge',
            },
            'offer': {
                'singular': 'Angebot',
                'plural': 'Angebote',
            },
            'incompleteContract': {
                'singular': 'Antrag',
                'plural': 'Anträge',
            },
        },
        weekydayMap: [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag',
        ],
        monthMap: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
        ],
        tileHeadlineMap: {
            'appointment': 'Termin buchen',
            'lastSearches': 'Vergleich fortsetzen',
            'offer': 'Angebot abschließen',
            'incompleteContract': 'Antrag fortsetzen',
            'contract': 'Ihr aktueller Vertrag',
            'staticTile': 'Versicherung nicht über uns abgeschlossen?',
            'promotion': 'Neue Aktion',
            'productSpecificTile': '',
            'consultant': 'Persönliche Beratung',
        },
        bClonedElementNonContracts: false,
        bClonedElementContracts: false,
        oElementTemplateLastSearches: null,
        oElementTemplateArrangement: null,
        oElementTemplateAppointment: null,
        oElementTemplateStaticTile: null,
        oElementTemplatePromotion: null,
        oElementTemplateProductSpecificTile: null,
        oElementTemplateConsultant: null,
        bClonedElementAppointment: false,
        bClonedElementPromotion: false,
        bClonedElementStaticTile: false,
        bClonedElementProductSpecificTile: false,
        bClonedElementConsultant: false,
        oElementTemplateContract: null,
        oElementTemplateFilterChip: null,
        oClonedElementFilterChip: false,
        bCommaAfterPerson: true,
        bCommaAfterPersonJob: true,
        bCommaAfterPersonCount: false,
        bContractsExists: true,
        bAppointmentsExists: true,
        bPromotionsExists: true,
        bProductSpecificTilesExists: true,
        bConsultantsExists: true,
        bNonContractsExists: true,
        bStaticTileExists: true,
        bPriceInCents: false, // Ist Preis in Cent
        bDecimalSeparator: true, // Preis mit dezimalstellen
        bThousandsSeparator: false, // preis mit tausender Trenner
        bShowContractId: true, // show publicId
        sLastUrl: '',
        bReloadIpssEventRegistered: false,
        sDeleteMethod: 'POST',
        sOriginalSubHead: false,
        showTeaserLabelInIpss: false,
        sRenderType: 'lastSearches',
        filterPersons: false, // Personentext Ersetzung UN
        bIpssTest: window.location.href.toLowerCase().indexOf('ipsstest') >= 0 && (!window.c24LpIsProduction || window.c24LpIpssDebug),
        overrideData: false, // Testdaten zum Entwickeln
        bShowContracts: false,
        elementRenderingDone: null,
        iElementRenderingCount: 0,
        renderingDone: null,
        iSortItems: 0, // 1: newest on top. 0: no sort. -1: oldest on top.,
        sortItemsBy: 'time', // keyname which will be used for sorting
        fadeTeaser: true,
        fadeTeaserDelay: 500,
        $ac: null,
        logId: '',
        initialContextHeight: 0,
        initialContextBottom: 0,
        initialBgImagePosition: '',
        autoSelectContractTab: false,
        showGreeting: true,
        bUseTilesLayout: false, // use new tiles layout
        showStaticTile: false,
        tilesOrder: [
            'appointments',
            'incompleteContracts',
            'offers',
            'lastSearches',
            'contracts',
            'consultants',
            'promotions',
            'productSpecificTiles',
        ],
        iAmountNonContracts: 0,
        iAmountLastSearches: 0,
        iAmountTotal: 0, // iAmountNonContracts + iAmountLastSearches
        iAmountContracts: 0,
        squareUrl: '/versicherungsordner/api/insurance-service/insurances/',
        filterChipLabelMap: {
            'showAll': 'alles anzeigen',
            'lastSearches': {
                'singular': 'Vergleich',
                'plural': 'Vergleiche',
            },
            'offer': {
                'singular': 'Angebot',
                'plural': 'Angebote',
            },
            'incompleteContract': {
                'singular': 'Antrag',
                'plural': 'Anträge',
            },
            'appointments': {
                'singular': 'Termin',
                'plural': 'Termine',
            },
            'contracts': {
                'singular': 'Vertrag',
                'plural': 'Verträge',
            },
        },
        bWholeTileClickable: true,
        bShowAllOnlyWhenFiltered: false, // show all items only when filter is active
        showFilterChips: true,
        staticTilePosition: undefined,
        wrappedStaticTile: undefined,
        isStaticTileInFlow: undefined,
        isWidgetPrefilledWithLastSearchData: false,
        prefilledLabelsKeys: {},
        prefilledLabels: {},
        hideSubtextWhenIpssIsActive: true,
        isBlueTeaser: false,
        fittingTariffsWithDate: false,
        bOnlyShowIfUserDataExists: false,
        ipssWrapperBackup: null,
        init: function(logId, sUrl, iTimeout) {
            const teaserElement = $(logId);
            this.bind(logId, sUrl, teaserElement, iTimeout);
        },

        bind: function(logId, sUrl, teaserElement, iTimeout) {
            const self = this;

            self.elementRenderingDone = $.Deferred();
            self.renderingDone = $.Deferred();

            self.logId = logId;
            self.domContext = teaserElement ?? $(logId);

            if (self.ipssWrapperBackup === null) {
                self.ipssWrapperBackup = $('.box24VsIpssWrapper', self.domContext).clone();
            }

            self.$ac = $('.box24VsIpssWrapper', self.domContext).closest('.mod24ac');

            self.bUseTilesLayout = self.$ac.data('use-tiles-layout');

            if (self.isStaticTileInFlow === undefined && !self.bIsMobile) {
                self.isStaticTileInFlow = self.bUseTilesLayout;
            } else if (self.bIsMobile) {
                self.isStaticTileInFlow = false;
            }

            if (self.$ac.hasClass('c24TeaserBlue')) {
                self.isBlueTeaser = true;
            }

            if ($('.tabNavi', self.domContext).length || self.bUseTilesLayout) {
                self.bShowContracts = true;
            }

            if (!$('.js24VsIpss', self.domContext).length) {
                return;
            }

            const contextRect = self.domContext[0].getBoundingClientRect();

            self.initialContextHeight = contextRect.height;
            self.initialContextBottom = contextRect.bottom + window.scrollY;

            const bgPosition = self.$ac.css('background-position');
            const bgPosRegex = /([-+]?(\d*\.?\d+%?|calc\([^)]*\)))/g;
            self.initialBgImagePosition = bgPosition.match(bgPosRegex);

            self.iTimeout = iTimeout || 6000;

            self.sLastUrl = sUrl;

            self.activateTracking();

            self.spinnerEvent();

            if (
                $('.box24VsIpss', self.domContext).length > 0
            || self.isLoadedFromCache()
            || self.bIpssTest
            ) {
                self.getAPiData(sUrl);
            }

            self.registerReloadIpssEvent();
        },

        reload: function() {
            const self = this;

            self.aApiDataResult = null;
            self.aNonContractsGrouped = null; // contains all data except type: 'contract'
            self.aContractsGrouped = null; // should contain only contracts with type: 'contract'
            self.aAppointmentsGrouped = null; // should contain only contracts with type: 'appointment'
            self.aStaticTilesGrouped = null; // should contain only infos about static tile
            self.aPromotionsGrouped = null; // should contain only infos about Promotions
            self.aProductSpecificTilesGrouped = null; // should contain only infos about product specific tiles
            self.aConsultantsGrouped = null; // should contain only infos about consultants

            self.bContractsExists = true;
            self.bAppointmentsExists = true;
            self.bPromotionsExists = true;
            self.bProductSpecificTilesExists = true;
            self.bNonContractsExists = true;
            self.bStaticTileExists = true;
            self.bConsultantsExists = true;

            self.elementRenderingDone = $.Deferred();
            self.iElementRenderingCount = 0;
            self.renderingDone = $.Deferred();

            self.iAmountNonContracts = 0;
            self.iAmountLastSearches = 0;
            self.iAmountTotal = 0; // iAmountNonContracts + iAmountLastSearches
            self.iAmountContracts = 0;

            self.bClonedElementNonContracts = false;
            self.bClonedElementContracts = false;
            self.oElementTemplateLastSearches = null;
            self.oElementTemplateArrangement = null;
            self.oElementTemplateAppointment = null;
            self.oElementTemplateStaticTile = null;
            self.oElementTemplatePromotion = null;
            self.oElementTemplateProductSpecificTile = null;
            self.oElementTemplateConsultant = null;
            self.bClonedElementAppointment = false;
            self.bClonedElementPromotion = false;
            self.bClonedElementStaticTile = false;
            self.bClonedElementProductSpecificTile = false;
            self.bClonedElementConsultant = false;
            self.oElementTemplateContract = null;
            self.oElementTemplateFilterChip = null;
            self.oClonedElementFilterChip = false;

            if (self.ipssWrapperBackup !== null) {
                $('.box24VsIpssWrapper', self.domContext).replaceWith(self.ipssWrapperBackup.clone());
            }

            self.bind(self.logId, self.sLastUrl, self.domContext, self.iTimeout);
        },

        elementRenderingAddRef: function() {
            this.iElementRenderingCount++;
        },

        elementRenderingRemoveRef: function() {
            this.iElementRenderingCount--;

            if (this.iElementRenderingCount === 0) {
                this.elementRenderingDone.resolve();
            }
        },

        getUrlParameterByName: function (name, emptyValueAllowed = false) {
            const url = new URL(window.location.href);
            const urlParam = url.searchParams.get(name);

            if (urlParam === '' && emptyValueAllowed) {
                return true;
            }

            return urlParam;
        },

        // Hole Api Daten
        getAPiData: function(sUrl) {
            const self = this;
            let oTestdata = undefined;

            if (
                self.bIpssTest
            ) {
                console.log('%cIPSS Test läuft! (' + self.logId + ')', 'font-size: 38px; font-weight: 700; color: #ff0000; text-shadow: 1px 1px 0px #000, 1px -1px 0px #000, -1px 1px 0px #000, -1px -1px 0px #000;');

                if (self.getUrlParameterByName('ipsstest', true)) {
                    try {
                        oTestdata = JSON.parse(self.getUrlParameterByName('ipsstest'));
                    } catch (e) {
                        oTestdata = undefined;
                    }
                }

                if (typeof oTestdata === 'undefined' || oTestdata === null || typeof oTestdata.version === 'undefined') {
                    if (typeof ipssTestDataPost !== 'undefined') {
                        oTestdata = window.ipssTestDataPost;
                    } else {
                        oTestdata = self.overrideData;
                    }
                }

                if (!oTestdata) {
                    console.log('keine Testdaten gefunden!');

                    return;
                }

                console.log(oTestdata);
                console.log('____________________________________________________________________________');


                self.aApiDataResult = JSON.parse(JSON.stringify(oTestdata));

                self.startIpssLogic();

                return;
            }

            const baseUrl = sUrl.split('?')[0];
            if (window.ipssFastLoad && window.ipssFastLoad[baseUrl]) {

                if (window.ipssFastLoad[baseUrl] === 'pending') {

                    setTimeout(function() {
                        self.getAPiData(sUrl);
                    }, 20);

                    return;

                } else {
                    const data = window.ipssFastLoad[baseUrl];

                    window.ipssFastLoad[baseUrl] = null;
                    self.aApiDataResult = JSON.parse(JSON.stringify(data));

                    self.startIpssLogic();
                }

            } else {
                $.ajax({
                    dataType: 'json',
                    url: sUrl,
                    xhrFields: {
                        withCredentials: true,
                    },
                    contentType: 'application/json; charset=UTF-8',
                    async: true,
                    timeout: this.iTimeout,
                    cache: false,

                }).done(function(data) {

                    self.aApiDataResult = JSON.parse(JSON.stringify(data));

                    self.startIpssLogic();

                }).fail(function() {
                    self.showDefaultTeaser(self);
                });
            }
        },

        startIpssLogic: function() {
            const self = this;

            self.elementRenderingAddRef();

            self.groupDataResult();
            self.sortDataResult(self.sortItemsBy);

            $('.box24VsIpss', self.domContext).trigger('c24IpssActive'); // tracking class

            // processing all nonContracts data
            self.handleNonContracts();

            // processing all contracts data
            self.handleContracts();

            // processing all contracts data
            self.handleAppointments();

            // processing all promotions data
            self.handlePromotions();

            // processing product specific tiles data
            self.handleProductSpecificTiles();

            // processing consultants data
            self.handleConsultants();

            // processing static tile
            if (self.bUseTilesLayout) {
                self.handleTiles();
            } else {
                self.bStaticTileExists = false;
            }

            self.handleInfoMessage();

            self.handleDeleteAllLinks();

            // removed because there are no user data after VC shutdown
            // self.handleUserData();

            self.elementRenderingRemoveRef();

            if (self.showFilterChips) {
                self.registerTilesFilterEvent();
            }

            self.elementRenderingDone.then(function() {

                // todo: simplify this logic
                if (
                    self.bNonContractsExists
                    || (self.bContractsExists && self.bShowContracts)
                    || self.bAppointmentsExists
                    || (self.bPromotionsExists && !self.bOnlyShowIfUserDataExists)
                    || (self.bStaticTileExists && !self.bOnlyShowIfUserDataExists)
                    || (self.bProductSpecificTilesExists && !self.bOnlyShowIfUserDataExists)
                    || (self.bConsultantsExists && !self.bOnlyShowIfUserDataExists)
                ) {
                    if (
                        self.bUseTilesLayout
                        && self.bStaticTileExists
                        && !self.bIsMobile
                        && !self.bNonContractsExists
                        && (!self.bContractsExists || !self.bShowContracts)
                        && !self.bAppointmentsExist
                        && !self.bPromotionsExists
                        && !self.bProductSpecificTilesExists
                        && !self.bConsultantsExists
                    ) {
                        self.staticTileOnlyLayout();
                    }

                    if (
                        self.bUseTilesLayout
                        && !self.bIsMobile
                        && !self.bNonContractsExists
                        && (!self.bContractsExists || !self.bShowContracts)
                        && !self.bAppointmentsExist
                    ) {
                        $('.ipssFilterContainer', self.domContext).remove();
                    }

                    self.showIpssTeaser();
                }
            });
        },

        groupDataResult: function() {
            const self = this;

            // if extended ipss is activated in ac module
            if (self.bShowContracts) {
                self.registerTabSwitchEvent();
            }

            self.sRenderType = 'ipss';

            self.aNonContractsGrouped = {};

            if (self.aApiDataResult.lastSearches) {
                self.aNonContractsGrouped.lastSearches = [ ];

                // add lastSearches
                self.aNonContractsGrouped.lastSearches = self.aApiDataResult.lastSearches;
            }

            if (self.aApiDataResult.contracts) {
                self.aNonContractsGrouped.contracts = [ ];

                // add all nonContracts
                self.aNonContractsGrouped.contracts = self.aApiDataResult.contracts.filter(function(item) {
                    return item.type === 'offer' || item.type === 'incompleteContract';
                });
            }

            if (self.aApiDataResult.appointments) {
                self.aAppointmentsGrouped = [ ];

                self.aAppointmentsGrouped = self.aApiDataResult.appointments;
            }

            if (self.aApiDataResult.promotions) {
                self.aPromotionsGrouped = [ ];

                self.aPromotionsGrouped = self.aApiDataResult.promotions;
            }

            if (self.aApiDataResult.productSpecificTiles) {
                self.aProductSpecificTilesGrouped = [ ];

                self.aProductSpecificTilesGrouped = self.aApiDataResult.productSpecificTiles;
            }

            if (self.aApiDataResult.consultants) {
                self.aConsultantsGrouped = [ ];

                self.aConsultantsGrouped = self.aApiDataResult.consultants;
            }

            if (self.bShowContracts) {
                self.aContractsGrouped = [];

                if (!self.aApiDataResult.contracts) {
                    self.aContractsGrouped = null;
                } else {
                // add all contracts
                    self.aContractsGrouped = self.aApiDataResult.contracts.filter(function(item) {
                        return item.type === 'contract';
                    });
                }
            }

            if (self.aApiDataResult?.staticTiles) {
                self.aStaticTilesGrouped = self.aApiDataResult.staticTiles;
            }

            self.setInitialActiveTab();
        },

        setInitialActiveTab: function () {
            const self = this;

            if (self.aContractsGrouped?.length > 0) {
                if (
                    self.autoSelectContractTab ||
                (
                    self.aNonContractsGrouped?.lastSearches?.length === 0 &&
                    self.aNonContractsGrouped?.contracts?.length === 0
                )
                ) {
                    const contractTabHeaderItem = $('.cssTabHeaderItem[data-contentbox^="contracts"]', this.domContext);

                    self.selectTab(contractTabHeaderItem);
                }
            }
        },

        sortDataResult: function(sortBy = 'time') {
            const self = this;

            // If we're not asked to sort, we won't sort.
            if (self.iSortItems == 0) {
                return;
            }

            const allIpssEntries = [
                self.aNonContractsGrouped.contracts ?? [], // nonContracts
                self.aNonContractsGrouped.lastSearches ?? [], // lastSearches
                self.aContractsGrouped ?? [], // contracts
            ];

            for (const groupedEntries of allIpssEntries) {
                if (groupedEntries.length < 2) {
                    return;
                }

                groupedEntries.sort((a, b) => {
                    if (!a[sortBy] || !b[sortBy]) {
                        return 0;
                    }

                    if (a[sortBy] < b[sortBy]) {
                        return self.iSortItems;
                    }

                    if (a[sortBy] > b[sortBy]) {
                        return self.iSortItems * -1;
                    }

                    return 0;
                });
            }
        },

        handleNonContracts: function() {
            const self = this;

            if (!self.isValidApiResponse(self.aNonContractsGrouped)) {
                self.showDefaultTeaser(self);

                self.noExistingNonContracts();

                if (!self.bShowContracts) {
                    return;
                }
            } else {
                self.renderList();
            }

            self.renderHeadline(self.aNonContractsGrouped);
        },

        handleAppointments: function() {
            const self = this;

            if (!self.isValidObjectWithContent(self.aAppointmentsGrouped)) {
                self.noExistingAppointments();
            } else {

                // quick fix for appointments without appointmentTime in old ipss
                if (!self.bUseTilesLayout) {
                    for (let i = 0; i < self.aAppointmentsGrouped.length; i++) {
                        if (!self.aAppointmentsGrouped[i].appointmentTime || self.aAppointmentsGrouped[i].appointmentTime === null) {
                            self.noExistingAppointments();
                            return;
                        }
                    }
                }

                self.renderListAppointments();

                self.renderHeadlineAppointments(self.aAppointmentsGrouped);
                self.showFilterChip('appointments', (self.aAppointmentsGrouped?.length > 1));
            }
        },
        handlePromotions: function() {
            const self = this;

            if (!self.isValidObjectWithContent(self.aPromotionsGrouped)) {
                self.noExistingPromotions();
            } else {
                self.renderListPromotions();
            }
        },

        handleProductSpecificTiles: function() {
            const self = this;

            if (!self.isValidObjectWithContent(self.aProductSpecificTilesGrouped)) {
                self.noExistingProductSpecificTiles();
            } else {
                self.renderListProductSpecificTiles();
            }
        },

        handleConsultants: function() {
            const self = this;

            if (!self.isValidObjectWithContent(self.aConsultantsGrouped)) {
                self.noExistingConsultants();
            } else {
                self.renderListConsultants();
            }
        },

        handleContracts: function() {
            const self = this;

            // handle contracts
            if (self.bShowContracts) {
                if (!self.isValidObjectWithContent(self.aContractsGrouped)) {
                    self.noExistingContracts();
                } else {
                    self.renderListContracts();

                    self.showFilterChip('contracts', (self.aContractsGrouped?.length > 1));
                }

                self.renderHeadlineContracts(self.aContractsGrouped);

            }
        },

        handleTiles: function() {
            const self = this;

            self.handleStaticTile();
            const {
                sortedLis, elementsMap,
            } = self.sortTiles();
            self.renderSortedTiles(elementsMap);
            if (self.isStaticTileInFlow && self.bStaticTileExists && !self.bIsMobile) {
                const position = self.determineStaticTilePosition(sortedLis);
                self.renderSortedTilesWithStatic(elementsMap, position, self.wrappedStaticTile);
                $('.staticTileBox').addClass('inFlow');
            }

            if (!self.bIsMobile) {
                $.when(self.renderingDone).done(function() {
                    self.registerTilesSliderEvents();
                });
            }
        },

        handleStaticTile: function() {
            const self = this;


            if (!self.isValidObjectWithContent(self.aStaticTilesGrouped)) {
                self.noExistingStaticTile();
                return;
            } else {
                self.showStaticTile = true;
                self.renderListStaticTile();
            }
        },

        renderSortedTiles: function(elementsMap, staticTilesList = undefined) {
            const self = this;
            const $container = $('.cssTabContentBox', self.domContext);
            $container.children('.ipssItemWrapper').remove();
            $.each(self.tilesOrder, function(index, type) {
                // check whether elements of the current type exist before creating a new container
                if (elementsMap[type] && elementsMap[type].length > 0) {
                    let $newUl;
                    if (type === 'staticTiles') {
                        if (typeof staticTilesList !== 'undefined' && self.isStaticTileInFlow) {
                            $newUl = staticTilesList;
                        }
                    } else {
                        $newUl = $('<ul>').addClass('ipssItemWrapper').addClass(`${type}Container`);
                    }

                    if ($newUl) $container.append($newUl);

                    $.each(elementsMap[type], function(i, $item) {
                        $newUl?.append($item);
                    });
                }
            });

        },
        renderSortedTilesWithStatic: function(elementsMap, position, staticTilesList) {
            const self = this;
            const $container = $('.cssTabContentBox', self.domContext);

            // Detach all existing item wrappers to preserve their events
            const existingWrappers = $container.children('.ipssItemWrapper').detach();

            let counter = 0;
            let staticTilesRendered = false;
            if (Object.keys(elementsMap).length === 0) {
                $container.append(staticTilesList);
                return;
            }

            if (position) {
                $.each(self.tilesOrder, function(index, type) {
                    if (elementsMap[type] && elementsMap[type].length > 0) {
                        if (counter + elementsMap[type].length < position || staticTilesRendered) {
                            // Find existing wrapper for this type or create new one if not found
                            let $newUl = existingWrappers.filter(`.${type}Container`).first();
                            if ($newUl.length === 0) {
                                $newUl = $('<ul>').addClass('ipssItemWrapper').addClass(`${type}Container`);
                            }

                            $.each(elementsMap[type], function(i, $item) {
                                $newUl.append($item);
                            });
                            counter += elementsMap[type].length;
                            if ($newUl.children('li').length > 0) {
                                $container.append($newUl);
                            }
                        } else {
                            const ulDivider = position - counter;
                            let $newUlLeft = existingWrappers.filter(`.${type}Container`).first();
                            let $newUlRight = $('<ul>').addClass('ipssItemWrapper').addClass(`${type}Container`);

                            if ($newUlLeft.length === 0) {
                                $newUlLeft = $('<ul>').addClass('ipssItemWrapper').addClass(`${type}Container`);
                            }

                            for (let i = 0; i < ulDivider; i++) {
                                $newUlLeft.append(elementsMap[type][i]);
                            }

                            for (let i = ulDivider; i < elementsMap[type].length; i++) {
                                $newUlRight.append(elementsMap[type][i]);
                            }

                            if ($newUlLeft.children('li').length > 0) {
                                $container.append($newUlLeft);
                            }
                            $container.append(staticTilesList);
                            if ($newUlRight.children('li').length > 0) {
                                $container.append($newUlRight);
                            }
                            staticTilesRendered = true;
                        }
                    }
                });

            } else {
                self.renderSortedTiles(elementsMap, staticTilesList);
            }
        },



        sortTiles: function() {
            const self = this;

            const $container = $('.cssTabContentBox', self.domContext);
            const elementsMap = {};
            // special handling for nonContractsContainer
            const $nonContractsContainer = $('.nonContractsContainer', $container);
            const $offersContainer = $('.offersContainer', $container);
            const $incompleteContractsContainer = $('.incompleteContractsContainer', $container);
            const nonContractsLis = $nonContractsContainer.children('li').toArray().concat($offersContainer.children('li').toArray()).concat($incompleteContractsContainer.children('li').toArray());
            $(nonContractsLis).each(function() {
                const $item = $(this);
                // check if 'offer' or 'incompleteContract'
                if ($item.hasClass('offer')) {
                    if (!elementsMap.offers) elementsMap.offers = [];
                    elementsMap.offers.push($item);
                } else if ($item.hasClass('incompleteContract')) {
                    if (!elementsMap.incompleteContracts) elementsMap.incompleteContracts = [];
                    elementsMap.incompleteContracts.push($item);
                }
            });

            $.each(self.tilesOrder, function(index, type) {
                if (type !== 'offers' && type !== 'incompleteContracts') {
                    const containerClass = `${type}Container`;
                    let $typeContainer = $(`.${containerClass}`, $container);
                    if (type === 'staticTiles' && self.isStaticTileInFlow) {
                        $typeContainer = self.wrappedStaticTile;
                    }
                    $('.ipssItem', $typeContainer).each(function() {
                        const $item = $(this);
                        if (!elementsMap[type]) elementsMap[type] = [];
                        elementsMap[type].push($item);
                    });
                }
            });

            const sortedLis = [];
            self.tilesOrder.forEach(type => {
                if (elementsMap[type] && elementsMap[type].length > 0) {
                    elementsMap[type].forEach($item => {
                        sortedLis.push($item.closest('.ipssItem').get(0));
                    });
                }
            });

            return {
                sortedLis,
                elementsMap,
            };
        },

        registerTilesSliderEvents() {
            const self = this;
            const $scrollContainer = $('.cssTabContentBox', self.domContext);
            const $navPrev = $('.staticSliderNav.navPrev', self.domContext);
            const $navNext = $('.staticSliderNav.navNext', self.domContext);

            let isMouseDown = false;
            let startX;
            let scrollLeft;
            let velocity = 0;
            let lastX;
            let frame;
            let ticking = false;
            let itemWidth;

            const updateScrollPosition = () => {
                $scrollContainer.scrollLeft($scrollContainer.scrollLeft() + velocity);
                velocity *= 0.95;

                if (Math.abs(velocity) > 0.5 || isMouseDown) {
                    frame = requestAnimationFrame(updateScrollPosition);
                } else {
                    ticking = false;
                    self.checkSliderArrowsVisibility();
                }
            };

            const styles = window.getComputedStyle(self.domContext[0]);

            const recalculateItemWidth = () => itemWidth = parseInt(styles.getPropertyValue('--tilesMarginX'), 10) * 2 + parseInt(styles.getPropertyValue('--tilesWidth'), 10) + parseInt(styles.getPropertyValue('--tilesGap'), 10); // Add column gap value

            if (!self.bWholeTileClickable) {
                $scrollContainer.on('mousedown', (e) => {
                    if (e.button !== 0) return; // Only left mouse button (0) is allowed
                    isMouseDown = true;
                    startX = e.pageX - $scrollContainer.offset().left;
                    scrollLeft = $scrollContainer.scrollLeft();

                    $scrollContainer.css({
                        cursor: 'grabbing',
                        userSelect: 'none',
                    });

                    lastX = startX;
                    velocity = 0;

                    if (frame) cancelAnimationFrame(frame);

                    $scrollContainer.on('mousemove', (e) => {
                        if (!ticking && isMouseDown) {
                            window.requestAnimationFrame(() => {
                                const x = e.pageX - $scrollContainer.offset().left;
                                velocity = (x - lastX) * -1; // Invert the direction of velocity
                                $scrollContainer.scrollLeft(scrollLeft + startX - x);
                                lastX = x;
                                ticking = false;
                            });
                            ticking = true;
                        }

                        self.checkSliderArrowsVisibility();
                    });
                });

                $(document).on('mouseup', () => {
                    if (isMouseDown) {
                        isMouseDown = false;
                        $scrollContainer.css({
                            cursor: 'grab',
                            userSelect: '',
                        });

                        if (Math.abs(velocity) > 0.5) {
                            frame = requestAnimationFrame(updateScrollPosition);
                        } else {
                            self.checkSliderArrowsVisibility(); // Ensure arrows are updated on release
                        }
                    }
                });
            }

            const scrollElement = (direction) => {
                if (itemWidth === undefined || itemWidth === 0) recalculateItemWidth();
                $scrollContainer.animate({
                    scrollLeft: `${direction}${itemWidth}`,
                }, 200, 'swing', self.checkSliderArrowsVisibility);
            };

            $navPrev.on('click', () => scrollElement('-='));
            $navNext.on('click', () => scrollElement('+='));

            $scrollContainer.on('scroll', () => {
                self.checkSliderArrowsVisibility();
            });

            // Initial state of arrows
            $navPrev.hide();
            // check if container is scrollable
            const isScrollable = $scrollContainer[0]?.scrollWidth > $scrollContainer[0]?.clientWidth;
            if (isScrollable) {
                $navNext.show(); // show next arrow if container is scrollable
            } else {
                $navNext.hide(); // hide next arrow if container is not scrollable
            }
        },

        checkSliderArrowsVisibility: function() {
            const $scrollContainer = $('.cssTabContentBox', this.domContext);
            const scrollTolerance = 5;

            if ($scrollContainer.length === 0) return;

            const $navPrev = $('.staticSliderNav.navPrev', this.domContext);
            const $navNext = $('.staticSliderNav.navNext', this.domContext);
            const maxScrollLeft = $scrollContainer[0].scrollWidth - $scrollContainer[0].clientWidth;

            $navPrev.toggle($scrollContainer.scrollLeft() > scrollTolerance);
            $navNext.toggle($scrollContainer.scrollLeft() < maxScrollLeft - scrollTolerance);
        },

        isValidApiResponse: function(data) {
            if (!data.lastSearches && !data.contracts) {
                return false;
            }

            let bReturnTestLastSearches = true;
            let bReturnTestNonContracts = true;

            if (!data.lastSearches || (typeof data.lastSearches != 'object') || !Array.isArray(data.lastSearches) || data.lastSearches.length < 1) {
                bReturnTestLastSearches = false;
            }

            if (!data.contracts || (typeof data.contracts != 'object') || !Array.isArray(data.contracts) || data.contracts.length < 1) {
                bReturnTestNonContracts = false;
            }

            if (!bReturnTestLastSearches && !bReturnTestNonContracts) {
                return false;
            }

            return true;
        },

        isValidObjectWithContent: function(data) {

            if (!data || (typeof data != 'object') || !Array.isArray(data) || data.length < 1) {
                return false;
            }

            return true;
        },

        noExistingNonContracts: function() {
            const self = this;
            const $lastSearchesDummyContainer = $('[id^=lastSearches]', self.domContext);

            self.bNonContractsExists = false;

            $lastSearchesDummyContainer.children('.ipssHeadline.lastSearches').remove();
            $lastSearchesDummyContainer.children('.ipssItemWrapper.lastSearchesContainer').remove();
            $lastSearchesDummyContainer.children('.ipssHeadline.nonContracts').remove();
            $lastSearchesDummyContainer.children('.ipssItemWrapper.nonContractsContainer').remove();

            if (self.bUseTilesLayout) {
                $('.ipssHeadline.activities', self.domContext).remove();
            }
        },

        noExistingAppointments: function() {
            const self = this;
            const $appointmentsContainer = $('.ipssItemWrapper.appointmentsContainer', this.domContext);

            self.bAppointmentsExists = false;

            if (!self.bUseTilesLayout) {
                $appointmentsContainer.prev('.ipssHeadline').remove();

            }
            if ($('.cssTabHeaderContainer', this.domContext).length > 0) {
                $appointmentsContainer.next('.ipssHeadline').remove();
            }
            $appointmentsContainer.remove();
        },


        noExistingPromotions: function() {
            const self = this;
            const $promotionsContainer = $('.ipssItemWrapper.promotionsContainer', this.domContext);

            self.bPromotionsExists = false;

            $promotionsContainer.remove();
        },

        noExistingProductSpecificTiles: function() {
            const self = this;
            const $productSpecificTilesContainer = $('.ipssItemWrapper.productSpecificTilesContainer', this.domContext);

            self.bProductSpecificTilesExists = false;

            $productSpecificTilesContainer.remove();
        },

        noExistingConsultants: function() {
            const self = this;
            const $consultantsContainer = $('.ipssItemWrapper.consultantsContainer', this.domContext);

            self.bConsultantsExists = false;

            $consultantsContainer.remove();
        },

        noExistingContracts: function() {
            const self = this;

            self.bContractsExists = false;

            if (self.bUseTilesLayout) {
                $('.ipssItemWrapper.contractsContainer', this.domContext).remove();
                $('.ipssHeadline.contracts', this.domContext).remove();
            } else {
                $('[id^="contracts"][data-status=loggedIn]', self.domContext).children('.ipssItemWrapper').remove();
            }
        },

        noExistingStaticTile: function() {
            const self = this;

            self.bStaticTileExists = false;

            $('.staticTileContainer', self.domContext).remove();
        },

        handleInfoMessage: function() {
            const self = this;

            if (self.bUseTilesLayout) {
                return;
            }

            if (self.bAppointmentsExists === false && self.bNonContractsExists === false) {
                const $lastSearchesDummyContainer = $('[id^=lastSearches]', self.domContext);

                self.addMissingInfo($lastSearchesDummyContainer, 'lastSearches');
            }

            if (self.bContractsExists === false) {
                const $contractsBox = $('[id^="contracts"][data-status=loggedIn]', self.domContext);

                self.addMissingInfo($contractsBox, 'contracts');
            }
        },

        renderHeadline: function(data) {
            const self = this;
            let amountHeadline;
            let typeHeadline;
            let amountHeadlineExtend = '';
            const newHeadline = {};
            const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext);
            const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);

            self.iAmountNonContracts = data.contracts ? data.contracts.length : 0;
            self.iAmountLastSearches = data.lastSearches ? data.lastSearches.length : 0;
            self.iAmountTotal = self.iAmountNonContracts + self.iAmountLastSearches;

            if (!self.isValidApiResponse(data)) {

                newHeadline.general = 'Meine letzte Aktivität';
                newHeadline.lastSearches = 'Meine letzten Vergleiche';
            } else {
                if (data.contracts && self.iAmountNonContracts > 0) {

                    typeHeadline = 'Aktivität';

                    if (self.iAmountTotal < 2) {
                        amountHeadline = 'Meine letzte ';
                        amountHeadlineExtend = '';
                    } else {
                        amountHeadline = 'Meine letzten ';
                        amountHeadlineExtend = 'en';
                    }

                    newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                }

                if (data.lastSearches) {

                    typeHeadline = 'Vergleich';

                    if (data.lastSearches.length < 2) {
                        amountHeadline = 'Mein letzter ';
                        amountHeadlineExtend = '';
                    } else {
                        amountHeadline = 'Meine letzten ';
                        amountHeadlineExtend = 'e';
                    }

                    newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                }
            }

            if (self.bShowContracts) {

                if (self.iAmountNonContracts < 1 && data.lastSearches) {
                    newHeadline.general = newHeadline.lastSearches;
                    newHeadline.lastSearches = null;
                }

                $tabHeadlineLastSearches.text(newHeadline.general);

                if (newHeadline.lastSearches === null && self.aAppointmentsGrouped?.length < 0) {
                    $headlineShowEverything.remove();
                } else {
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }

            } else {
                $('[id^="lastSearches"] .ipssHeadline.nonContracts', self.domContext).text(newHeadline.general);
                $headlineShowEverything.text(newHeadline.lastSearches);
            }

            if (self.bUseTilesLayout && self.bIsMobile) {
                $('.ipssHeadline.activities', self.domContext).text(`Meine Aktivitäten (${self.iAmountTotal})`);
            }
        },

        renderHeadlineAppointments: function(data) {
            const self = this;
            let _sHeadlineAppointments = '';
            const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', self.domContext);

            if (data.length > 1) {
                _sHeadlineAppointments = 'Meine nächsten Termine';
            } else {
                _sHeadlineAppointments = 'Mein nächster Termin';
            }

            $('.ipssHeadline.appointments', self.domContext).text(_sHeadlineAppointments);
            $tabHeadlineLastSearches.text(_sHeadlineAppointments);

            if ($('.ipssHeadline.appointments', self.domContext).nextAll('.ipssHeadline').length > 0) {
                let headlineNonContracts;

                if (self.aNonContractsGrouped?.contracts?.length > 1) {
                    headlineNonContracts = 'Meine letzten Anfragen';
                } else {
                    headlineNonContracts = 'Meine letzte Anfrage';
                }

                $tabHeadlineLastSearches.text(headlineNonContracts);

                $('.ipssHeadline.appointments', self.domContext).nextAll('.ipssHeadline')[0].innerText = headlineNonContracts;
            }
        },

        renderHeadlineContracts: function(data) {
            const self = this;
            let _sHeadline = '';

            self.iAmountContracts = data?.length ?? 0;

            if (self.iAmountContracts > 1) {
                _sHeadline = 'Meine Verträge';

                $('[data-contentbox^="contracts-"] .contractsCounter', self.domContext).text('(' + self.iAmountContracts + ')');
            } else {
                _sHeadline = 'Mein Vertrag';

                $('[data-contentbox^="contracts-"] .contractsCounter', self.domContext).remove();
            }

            $('.wordingContracts', self.domContext).text(_sHeadline);

            if (self.bUseTilesLayout && self.bIsMobile) {
                $('.ipssHeadline.contracts', self.domContext).text(`${_sHeadline} (${self.iAmountContracts})`);
            }
        },

        renderList: function() {
            const self = this;
            let bLastSearchesRendered = false;
            let bNonContractsRendered = false;

            // if the list had been already rendered before, clear it
            if (self.bClonedElementNonContracts) {
                if (self.bShowContracts) {
                    // remove only nonContracts blocks
                    $('.cssTabContentBox[id^=lastSearches] .ipssItem', self.domContext).remove();
                } else {
                    $('.ipssItemWrapper .ipssItem', self.domContext).remove();
                }
            }

            $.each(self.aNonContractsGrouped, function(key, value) {
                if (key === 'lastSearches' || key === 'contracts') {
                    value.forEach(function(data) {
                        if (value.length < 1) {
                            if (key === 'contracts') {
                                $('[id^="lastSearches"] .ipssHeadline.nonContracts', self.domContext).remove();
                                $('[id^="lastSearches"] .ipssItemWrapper.nonContractsContainer', self.domContext).remove();
                            }

                            if (key === 'lastSearches') {
                                $('[id^="lastSearches"] .ipssHeadline.lastSearches', self.domContext).remove();
                                $('[id^="lastSearches"] .ipssItemWrapper.lastSearchesContainer', self.domContext).remove();
                            }
                        } else {
                            self.sRenderType = data?.type ?? 'lastSearches';

                            self.showFilterChip(
                                self.sRenderType,
                                value.filter(
                                    item => item.type === self.sRenderType || typeof item.type === 'undefined',
                                ).length > 1,
                            );

                            if (key === 'lastSearches') {
                                bLastSearchesRendered = true;
                            }

                            if (key === 'contracts') {
                                bNonContractsRendered = true;
                            }

                            self.buildNonContracts(data);
                        }
                    });
                } else {
                    return;
                }
            });

            if (bNonContractsRendered === false) {
                $('[id^="lastSearches"] .ipssItemWrapper.nonContractsContainer', this.domContext).remove();
                $('[id^="lastSearches"] .ipssHeadline.nonContracts', this.domContext).remove();
            }

            if (bLastSearchesRendered === false) {
                $('[id^="lastSearches"] .ipssItemWrapper.lastSearchesContainer', this.domContext).remove();
                $('[id^="lastSearches"] .ipssHeadline.lastSearches', this.domContext).remove();
            }
        },

        renderListContracts: function() {
            const self = this;

            self.sRenderType = 'contract';

            // if the list had been already rendered before, clear it
            if (self.bClonedElementContracts) {
            // remove only contract blocks
                if (self.bUseTilesLayout) {
                    $('.cssTabContentBox[id^=lastSearches] .ipssItem.contract', self.domContext).remove();
                } else {
                    $('.cssTabContentBox[id^=contracts] .ipssItem', self.domContext).remove();
                }
            }

            this.aContractsGrouped.forEach(function(data) {
                self.buildContracts(data);
            });
        },

        renderListAppointments: function() {
            const self = this;

            self.sRenderType = 'appointment';

            // if the list had been already rendered before, clear it
            if (self.bClonedElementAppointment) {
            // remove only appointment blocks
                $('.ipssItemWrapper.appointmentsContainer .ipssItem.appointment', this.domContext).remove();
            }

            this.aAppointmentsGrouped.forEach(function(data) {
                self.buildAppointments(data);
            });
        },

        renderListPromotions: function() {
            const self = this;

            self.sRenderType = 'promotion';

            // if the list had been already rendered before, clear it
            if (self.bClonedElementPromotion) {
            // remove only promotions blocks
                $('.ipssItemWrapper.promotionsContainer .ipssItem.promotion', this.domContext).remove();
            }

            this.aPromotionsGrouped.forEach(function(data) {
                self.buildPromotions(data);
            });
        },

        renderListProductSpecificTiles: function() {
            const self = this;

            self.sRenderType = 'productSpecificTile';

            // if the list had been already rendered before, clear it
            if (self.bClonedElementProductSpecificTile) {
            // remove only product specific tiles blocks
                $('.ipssItemWrapper.productSpecificTilesContainer .ipssItem.productSpecificTile', this.domContext).remove();
            }

            this.aProductSpecificTilesGrouped.forEach(function(data) {
                self.buildProductSpecificTiles(data);
            });
        },

        renderListConsultants: function() {
            const self = this;
            self.sRenderType = 'consultant';

            // if the list had been already rendered before, clear it
            if (self.bClonedElementConsultant) {
            // remove only consultants blocks
                $('.ipssItemWrapper.consultantsContainer .ipssItem.consultant', this.domContext).remove();
            }

            this.aConsultantsGrouped.forEach(function(data) {
                self.buildConsultants(data);
            });
        },

        renderListStaticTile: function() {
            const self = this;

            self.sRenderType = 'staticTile';

            // if the list had been already rendered before, clear it
            if (self.bClonedElementStaticTile) {
            // remove only staticTile blocks
                $('.ipssItem.staticTileBox', this.domContext).remove();
            }

            this.aStaticTilesGrouped.forEach(function(data) {
                self.buildStaticTile(data);
            });
        },

        buildNonContracts: function(data) {
            const self = this;

            self.buildIpssElement(data, self.renderDataArray(data), self.createNonContract());
        },

        buildContracts: function(data) {
            const self = this;

            self.buildIpssElement(data, self.renderDataArrayContract(data), self.createContract());
        },

        buildAppointments: function(data) {
            const self = this;

            self.buildIpssElement(data, self.renderDataArrayAppointment(data), self.createAppointment());
        },


        buildPromotions: function(data) {
            const self = this;

            self.buildIpssElement(data, self.renderDataArrayPromotion(data), self.createPromotion());
        },

        buildProductSpecificTiles: function(data) {
            const self = this;

            self.buildIpssElement(data, self.renderDataArrayProductSpecificTile(data), self.createProductSpecificTile());
        },

        buildConsultants: function(data) {
            const self = this;
            self.buildIpssElement(data, self.renderDataArrayConsultantTile(data), self.createConsultant());
        },

        buildStaticTile: function(data) {
            const self = this;

            self.buildIpssElement(data, self.renderDataArrayStaticTile(data), self.createStaticTile(self.isStaticTileInFlow));
        },

        buildIpssElement: function(data, dataPromise, element) {
            const self = this;
            self.elementRenderingAddRef();
            dataPromise.then(function(data) {
                self.renderElement(element, data);
                self.elementRenderingRemoveRef();
            });
        },

        createNonContract: function() {
            const self = this;
            let newElement;

            if (!self.bClonedElementNonContracts) {
                self.oElementTemplateLastSearches = $('.ipssItemWrapper.lastSearchesContainer .ipssItem.lastSearches', self.domContext).clone();
                $('.ipssItemWrapper.lastSearchesContainer .ipssItem.lastSearches', self.domContext).remove();

                self.oElementTemplateArrangement = $('.ipssItemWrapper .ipssItem.noncontracts', self.domContext).clone();
                $('.ipssItem.noncontracts', self.domContext).remove();

                self.bClonedElementNonContracts = true;
            }

            if (self.sRenderType === 'lastSearches') {
                $('.lastSearchesContainer', self.domContext).show();

                newElement = self.oElementTemplateLastSearches.clone();
                newElement.appendTo($('.ipssItemWrapper.lastSearchesContainer', self.domContext));
            } else {
                if ($('.ipssItemWrapper.lastSearchesContainer .ipssItem', self.domContext).length < 1) {
                    $('.lastSearchesContainer', self.domContext).hide();
                }

                $('.ipssItemWrapper.nonContractsContainer .ipssItem.lastSearches', self.domContext).remove();

                newElement = self.oElementTemplateArrangement.clone();
                newElement.appendTo($('.ipssItemWrapper.nonContractsContainer', self.domContext));
            }

            if (!newElement.hasClass(self.sRenderType)) {
                newElement.addClass(self.sRenderType);
            }

            return newElement;
        },

        createContract: function() {
            const self = this;

            if (!self.bClonedElementContracts) {
                self.oElementTemplateContract = $('.ipssItem.contract', self.domContext).clone();
                $('.ipssItem.contract', self.domContext).remove();

                self.bClonedElementContracts = true;
            }

            const newElement = self.oElementTemplateContract.clone();
            if (self.bUseTilesLayout) {
                newElement.appendTo($('.ipssItemWrapper.contractsContainer', self.domContext));
            } else {
                newElement.appendTo($('[id^="contracts"] .ipssItemWrapper', this.domContext));
            }

            if (!newElement.hasClass(self.sRenderType)) {
                newElement.addClass(self.sRenderType);
            }

            return newElement;
        },

        createAppointment: function() {
            const self = this;
            if (!self.bClonedElementAppointment) {
                self.oElementTemplateAppointment = $('.ipssItem.appointment', self.domContext).clone();
                $('.ipssItem.appointment', self.domContext).remove();

                self.bClonedElementAppointment = true;
            }

            const newElement = self.oElementTemplateAppointment.clone();
            if (self.bUseTilesLayout) {
                newElement.appendTo($('.ipssItemWrapper.appointmentsContainer', self.domContext));
            } else {
                newElement.appendTo($('[id^="lastSearches"] .ipssItemWrapper.appointmentsContainer', this.domContext));
            }

            if (!newElement.hasClass(self.sRenderType)) {
                newElement.addClass(self.sRenderType);
            }

            return newElement;
        },

        createPromotion: function() {
            const self = this;
            if (!self.bClonedElementPromotion) {
                self.oElementTemplatePromotion = $('.ipssItem.promotion', self.domContext).clone();
                $('.ipssItem.promotion', self.domContext).remove();

                self.bClonedElementPromotion = true;
            }

            const newElement = self.oElementTemplatePromotion.clone();
            newElement.appendTo($('[id^="lastSearches"] .ipssItemWrapper.promotionsContainer', this.domContext));

            if (!newElement.hasClass(self.sRenderType)) {
                newElement.addClass(self.sRenderType);
            }

            return newElement;

        },

        createProductSpecificTile: function() {
            const self = this;

            if (!self.bClonedElementProductSpecificTile) {
                self.oElementTemplateProductSpecificTile = $('.ipssItem.productSpecificTile', self.domContext).clone();
                $('.ipssItem.productSpecificTile', self.domContext).remove();

                self.bClonedElementProductSpecificTile = true;
            }

            const newElement = self.oElementTemplateProductSpecificTile.clone();
            newElement.appendTo($('.ipssItemWrapper.productSpecificTilesContainer', self.domContext));

            if (!newElement.hasClass(self.sRenderType)) {
                newElement.addClass(self.sRenderType);
            }

            return newElement;
        },

        createConsultant: function() {
            const self = this;

            if (!self.bClonedElementConsultant) {
                self.oElementTemplateConsultant = $('.ipssItem.consultant', self.domContext).clone();
                $('.ipssItem.consultant', self.domContext).remove();

                self.bClonedElementConsultant = true;
            }

            const newElement = self.oElementTemplateConsultant.clone();
            newElement.appendTo($('.ipssItemWrapper.consultantsContainer', self.domContext));

            if (!newElement.hasClass(self.sRenderType)) {
                newElement.addClass(self.sRenderType);
            }

            return newElement;
        },

        createStaticTile: function(isStaticTileInFlow) {
            const self = this;

            if (!self.bClonedElementStaticTile) {
                self.oElementTemplateStaticTile = $('.ipssItem.staticTileBox', self.domContext).clone();
                $('.ipssItem.staticTileBox', self.domContext).remove();

                self.bClonedElementStaticTile = true;
            }

            const newElement = self.oElementTemplateStaticTile.clone();

            newElement.appendTo($('.staticTileContainer', this.domContext));

            if (!newElement.hasClass(self.sRenderType)) {
                newElement.addClass(self.sRenderType);
            }

            if (!newElement.hasClass(self.sRenderType)) {
                newElement.addClass(self.sRenderType);
            }

            const $container = $('.cssTabContentBox', self.domContext);

            if (isStaticTileInFlow && !self.bIsMobile && $container.children('.ipssItemWrapper').length) {
                $('.staticTileContainer').remove();
                const liElement = $('<li>', {
                    'class': 'ipssItem staticTileBox staticTile',
                    'html': newElement.html(),
                });
                self.wrappedStaticTile = $('<ul class="ipssItemWrapper staticTileInFlowContainer"></ul>').append(liElement);
                return liElement;
            } else {
                return newElement;
            }
        },

        renderDataArray: function(data) {
            const self = this;
            const aDataArray = {};

            if (!data) {
                return false;
            }

            const ret = $.Deferred();

            if (self.sRenderType === 'lastSearches') {
                const dataResult = data.result;
                dataResult.time = data.time;

                // create Array for lastSearches
                $.extend(aDataArray, self.renderDataArrayCategoryType()); // set category value
                $.extend(aDataArray, self.renderDataArrayIcons(dataResult)); // icons
                $.extend(aDataArray, self.renderDataArrayLabels(dataResult, data.time)); // persons
                $.extend(aDataArray, self.renderDataArrayToDos(dataResult)); // toDos
                $.extend(aDataArray, self.renderDataArrayMetaData(data)); // device & timestamp
                $.extend(aDataArray, self.renderDataArrayTariffDetails(dataResult.tariff)); // tariff
                $.extend(aDataArray, self.renderDataArrayCta(dataResult.cta)); // cta
                $.extend(aDataArray, self.renderDataArrayLinking(dataResult)); // delete url


                if (self.bUseTilesLayout) {
                    aDataArray.tileHeadline = 'Vergleich fortsetzen';
                }

                if (self.isWidgetPrefilledWithLastSearchData) {
                    self.getLastSearchesLabelsForPrefilledForm(data);
                }

                // set insuranceName
                if (dataResult.inputs.insuranceKey) {
                    $.ajax({
                        dataType: 'json',
                        url: self.squareUrl + dataResult.inputs.insuranceKey?.toLowerCase() + '/',
                        contentType: 'application/json; charset=UTF-8',
                        cache: true,
                        timeout: 4000,
                    }).done(function(insuranceData) {
                        aDataArray.labels.insuranceName = insuranceData?.data?.name ?? data.insuranceKey;
                    }).fail(function() {
                        aDataArray.labels.insuranceName = data.insuranceKey;
                    }).always(function() {
                        ret.resolve(aDataArray);
                    });
                } else {
                    aDataArray.labels.insuranceName = null;

                    ret.resolve(aDataArray);
                }

            } else {
            // create array for incompleteContracts and offers
                $.extend(aDataArray, self.renderDataArrayCategoryType(data.type)); // set category value
                $.extend(aDataArray, self.renderDataArrayIcons(data)); // insurance key for icon
                $.extend(aDataArray, self.renderDataArrayLabels(data)); // insurance key for name
                $.extend(aDataArray, self.renderDataArrayToDos(data)); // toDos
                $.extend(aDataArray, self.renderDataArrayMetaData(data)); // status
                $.extend(aDataArray, self.renderDataArrayTariffDetails(data.tariff)); // tariff
                $.extend(aDataArray, self.renderDataArrayCta(data.cta)); // cta
                $.extend(aDataArray, self.renderDataArrayLinking(data));

                // set insuranceName
                if (data.insuranceKey) {
                    $.ajax({
                        dataType: 'json',
                        url: self.squareUrl + data.insuranceKey?.toLowerCase() + '/',
                        contentType: 'application/json; charset=UTF-8',
                        cache: true,
                        timeout: 4000,
                    }).done(function(insuranceData) {
                        aDataArray.labels.insuranceName = insuranceData?.data?.name ?? data.insuranceKey;
                    }).fail(function() {
                        aDataArray.labels.insuranceName = data.insuranceKey;
                    }).always(function() {
                        ret.resolve(aDataArray);
                    });
                }
            }

            if (self.bUseTilesLayout) {
                $.extend(aDataArray, self.renderDataArrayTileHeadline(self.sRenderType, data));
            }

            return ret.promise();
        },

        renderDataArrayContract: function(data) {
            if (!data) {
                return false;
            }

            const self = this;
            const aDataArray = {};
            const ret = $.Deferred();

            $.extend(aDataArray, self.renderDataArrayCategoryType(data.type)); // set category value
            $.extend(aDataArray, self.renderDataArrayIcons(data)); // insurance key for icon
            $.extend(aDataArray, self.renderDataArrayLabels(data)); // insurance key for name
            $.extend(aDataArray, self.renderDataArrayToDos(data)); // toDos
            $.extend(aDataArray, self.renderDataArrayMetaData(data)); // status
            $.extend(aDataArray, self.renderDataArrayRatingTags(data)); // rating tags
            $.extend(aDataArray, self.renderDataArrayTariffDetails(data.tariff)); // tariff
            $.extend(aDataArray, self.renderDataArrayCta(data.cta)); // cta
            $.extend(aDataArray, self.renderDataArrayLinking(data));

            if (self.bUseTilesLayout) {
                $.extend(aDataArray, self.renderDataArrayTileHeadline(self.sRenderType));
            }

            // set insuranceName
            if (data.insuranceKey) {
                $.ajax({
                    dataType: 'json',
                    url: self.squareUrl + data.insuranceKey?.toLowerCase() + '/',
                    contentType: 'application/json; charset=UTF-8',
                    cache: true,
                    timeout: 4000,
                }).done(function(insuranceData) {
                    aDataArray.labels.insuranceName = insuranceData?.data?.name ?? data.insuranceKey;
                }).fail(function() {
                    aDataArray.labels.insuranceName = data.insuranceKey;
                }).always(function() {
                    ret.resolve(aDataArray);
                });
            }

            return ret.promise();
        },

        renderDataArrayAppointment: function(data) {
            if (!data) {
                return false;
            }

            const self = this;
            const aDataArray = {};
            const ret = $.Deferred();

            let message = data.message;

            if (self.bUseTilesLayout) {
                let tilesMessage = {};
                tilesMessage.body = ['Haben Sie Fragen zur Berufsunfähigkeits&shy;versicherung?', 'Ich berate Sie gerne.'];

                if (self.bIsMobile) {
                    tilesMessage.body = ['und von Expertenberatung profitieren.'];
                }

                message = tilesMessage;
            } else {
                message = data.message;
            }

            $.extend(aDataArray, self.renderDataArraySalutation(data));
            $.extend(aDataArray, self.renderDataArrayConsultant(data.consultant));
            $.extend(aDataArray, self.renderDataArrayMessage(message, 'ich freue mich auf unseren gemeinsamen Termin!')); // message
            $.extend(aDataArray, self.renderDataArrayTimeToDate(data.appointmentTime));
            $.extend(aDataArray, self.renderDataArrayLabels(data));
            $.extend(aDataArray, self.renderDataArrayCta(data.cta)); // cta
            $.extend(aDataArray, self.renderDataArrayLinking(data));

            if (self.bUseTilesLayout) {
                $.extend(aDataArray, self.renderDataArrayTileHeadline(self.sRenderType, data));
            }

            ret.resolve(aDataArray);

            return ret.promise();
        },

        renderDataArrayPromotion: function(data) {
            if (!data) {
                return false;
            }

            const self = this;
            const aDataArray = {};
            const ret = $.Deferred();

            $.extend(aDataArray, self.renderDataArrayCta(data.cta)); // cta
            $.extend(aDataArray, self.renderDataArrayLinking(data));
            $.extend(aDataArray, self.renderDataArrayLabels(data));
            if (self.bUseTilesLayout) {
                $.extend(aDataArray, self.renderDataArrayTileHeadline(self.sRenderType, data));
            }

            if (data?.tariff) {
                $.extend(aDataArray, self.renderDataArrayTariffDetails(data.tariff)); // tariff
            }

            ret.resolve(aDataArray);

            return ret.promise();
        },

        renderDataArrayProductSpecificTile: function(data) {
            if (!data) {
                return false;
            }

            const self = this;
            const aDataArray = {};
            const ret = $.Deferred();
            let message = data.message;

            if (self.bUseTilesLayout && data.type === 'rentenluecke') {
                let tilesMessage = {};
                tilesMessage.body = ['Finden Sie heraus, wie hoch Ihre Rentenlücke ist – jetzt fortsetzen!'];

                if (self.bIsMobile) {
                    tilesMessage.body = ['Jetzt Rentenlücke', 'berechnen lassen!'];
                }

                message = tilesMessage;
            } else {
                message = data.message;
            }

            $.extend(aDataArray,
                self.renderDataArrayCategoryType(data.type),
                self.renderDataArrayCta(data.cta), // cta
                self.renderDataArrayLinking(data),
                self.renderDataArrayLabels(data),
                self.renderDataArrayMessage(message),
                self.renderDataArrayIcons(data),
                self.renderDataArrayMetaData(data),
                self.renderDataArrayTileHeadline(self.sRenderType, data),
            );

            ret.resolve(aDataArray);

            return ret.promise();
        },

        renderDataArrayStaticTile: function(data) {
            if (!data) {
                return false;
            }

            const self = this;
            const aDataArray = {};
            const ret = $.Deferred();

            $.extend(aDataArray, self.renderDataArrayCta(data.cta)); // cta
            $.extend(aDataArray, self.renderDataArrayLinking(data));
            $.extend(aDataArray, self.renderDataArrayTileHeadline(self.sRenderType));

            if (data.message?.salutation) {
                $.extend(aDataArray, self.renderDataArraySalutation(data));
            }

            if (data?.consultant) {
                $.extend(aDataArray, self.renderDataArrayConsultant(data.consultant));
            }


            ret.resolve(aDataArray);

            return ret.promise();
        },

        renderDataArrayConsultantTile: function(data) {
            if (!data) {
                return false;
            }

            const self = this;
            const aDataArray = {};
            const ret = $.Deferred();

            $.extend(aDataArray, self.renderDataArrayCta(data.cta)); // cta
            $.extend(aDataArray, self.renderDataArrayLinking(data));
            $.extend(aDataArray, self.renderDataArrayTileHeadline(self.sRenderType));

            if (data.message?.salutation) {
                $.extend(aDataArray, self.renderDataArraySalutation(data));
            }

            if (data?.consultant) {
                $.extend(aDataArray, self.renderDataArrayConsultant(data.consultant));
            }


            ret.resolve(aDataArray);

            return ret.promise();
        },

        stripHtml: function (html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');

            return doc.body.textContent || '';
        },

        textToHtml: function (string) {
            const htmlReplacementMap = {
                'strong': '*', // bold
                'i': '_', // italic
                'u': '+', // underline
                's': '-', // strikethrough
            };

            let withHtml = '';

            for (const [tag, needle] of Object.entries(htmlReplacementMap)) {
                if (withHtml) {
                    string = withHtml;
                }

                const regEx = new RegExp('\\' + needle + '\\' + needle + '(.*?)\\' + needle + '\\' + needle + '', 'g');

                withHtml = string.replace(regEx, '<' + tag + '>$1</' + tag + '>');
            }

            return withHtml;
        },

        formatPrice: function(iPrice, sPriceUnit, bDecimalSeparator, bPriceInCents, thousandsSeparator) {
            let rawPrice;
            let sPrice;

            sPriceUnit = typeof sPriceUnit !== 'undefined' ? this.priceUnitMap[sPriceUnit] : this.priceUnitMap.euro;
            bPriceInCents = typeof bPriceInCents !== 'undefined' ? bPriceInCents : this.bPriceInCents;
            bDecimalSeparator = typeof bDecimalSeparator !== 'undefined' ? bDecimalSeparator : this.bDecimalSeparator;
            thousandsSeparator = typeof thousandsSeparator !== 'undefined' ? thousandsSeparator : this.bThousandsSeparator;

            if (iPrice === 0) {
                return '00,00 ' + sPriceUnit;
            }

            if (bPriceInCents) {
                rawPrice = iPrice / 100;
            } else {
                rawPrice = iPrice;
            }

            if (bDecimalSeparator === true) {
                sPrice = rawPrice.toFixed(2).replace('.', ',');
            } else {
                sPrice = rawPrice.toFixed().replace('.', ',');
            }


            if (thousandsSeparator === true) {
                sPrice = sPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
            }

            sPrice += ' ' + sPriceUnit;

            return sPrice;
        },

        capitalizeFirstLetter: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },

        addLeadingZero: function(value) {
            if (value?.toString()?.length === 1) {
                return '0' + value;
            }

            return value;
        },

        fnValueMerge: function(input, fieldname) {
            const arrayInput = Array.isArray(input) ? input : [input];

            return arrayInput.reduce(function(accumulator, currentValue, index) {
                if (!currentValue[fieldname]) {
                    return null;
                }

                if (accumulator === null) {
                    return null;
                }

                if (index === 0) {
                    return currentValue[fieldname];
                }
                return accumulator + ', ' + currentValue[fieldname];
            }, '');
        },

        isIsoDate: function (isoString) {
            if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(isoString)) {
                return false;
            }

            const date = new Date(isoString);

            return (date instanceof Date && !isNaN(date) && date.toISOString() === isoString); // valid date
        },

        isValidDate: function(timestamp) {
            return timestamp instanceof Date && !isNaN(timestamp);
        },

        fnIsoToDate: function(input) {
            const aReturn = {};
            const self = this;

            if (!self.isIsoDate(input)) {
                return false;
            }

            const date = new Date(input);

            aReturn.day = {
                'name': self.weekydayMap[date.getDay()],
                'number': self.addLeadingZero(date.getDate()),
            };

            aReturn.month = {
                'name': self.monthMap[date.getMonth()],
                'number': self.addLeadingZero(date.getMonth() + 1),
            };

            aReturn.year = self.addLeadingZero(date.getFullYear());
            aReturn.hours = self.addLeadingZero(date.getHours());
            aReturn.minutes = self.addLeadingZero(date.getMinutes());

            return aReturn;
        },

        fnUnixToDate: function(input) {
            const aReturn = {};
            const self = this;

            const date = new Date(input * 1000);

            if (!input || !self.isValidDate(date)) {
                return false;
            }

            aReturn.day = {
                'name': self.weekydayMap[date.getDay()],
                'number': self.addLeadingZero(date.getDate()),
            };

            aReturn.month = {
                'name': self.monthMap[date.getMonth()],
                'number': self.addLeadingZero(date.getMonth() + 1),
            };

            aReturn.year = self.addLeadingZero(date.getFullYear());
            aReturn.hours = self.addLeadingZero(date.getHours());
            aReturn.minutes = self.addLeadingZero(date.getMinutes());

            return aReturn;
        },

        renderDataArrayCategoryType: function(data) {
            const aDataArray = {};

            if (!data) {
                aDataArray.categoryType = 'lastSearches';
            } else {
                aDataArray.categoryType = data;
            }

            return aDataArray;
        },

        renderDataArrayIcons: function(data) {
            const self = this;
            const aDataArray = {};
            const aPersons = (data?.inputs?.persons?.type) ? data.inputs.persons : null;
            let iconKey = '';
            let icon = '';

            aDataArray.icon = {};

            if (data.insuranceKey) {
                aDataArray.icon.insurance = {};
                aDataArray.icon.insurance.html = self.squareUrl + data.insuranceKey?.toLowerCase() + '/logo';
            }

            if (self.bUseTilesLayout && data?.insuranceKeys) {
                aDataArray.icon.inputs = {
                    html: [],
                };

                for (const insuranceKey of data.insuranceKeys) {
                    aDataArray.icon.inputs.html.push(self.squareUrl + insuranceKey?.toLowerCase() + '/logo');
                }

                aDataArray.icon.inputs.html.slice(0, 6);
            }

            if (self.bUseTilesLayout && data?.image) {
                aDataArray.icon.inputs = {
                    html: [],
                };
                let imageUrl = '';

                switch (self.getDeviceType(self)) {
                    case 'app':
                        imageUrl = data?.image?.urlApp ?? data?.image?.urlMobile;
                        break;
                    case 'tabletApp':
                        imageUrl = data?.image?.urlTabletApp ?? data?.image?.urlDesktop;
                        break;
                    case 'mobile':
                        imageUrl = data?.image?.urlMobile;
                        break;
                    case 'desktop':
                        imageUrl = data?.image?.urlDesktop;
                        break;
                }

                aDataArray.icon.inputs.html = imageUrl ?? null;
            }

            if (data.inputs && data.inputs.personGroupKey) {
                iconKey = data.inputs.personGroupKey;
            } else if (aPersons && aPersons[0]) {
                iconKey = aPersons[0].type;
            } else if (data.inputs && data.inputs.icon) {
                iconKey = data.inputs.icon;
            }

            if (iconKey !== '' && (!aDataArray.icon?.inputs || self.bIsMobile)) {
                icon = self.iconMap[iconKey] || '';

                aDataArray.icon.inputs = {};

                aDataArray.icon.inputs.iconKey = iconKey;

                aDataArray.icon.inputs.html = icon;
            }

            if (data.type === 'rentenluecke' && self.bUseTilesLayout) {
                aDataArray.icon.inputs = {};
                let iconClass = '';
                if (data.inputs.pensionGap) {
                    iconClass = 'rentenlueckeWithPensionGap';
                } else {
                    iconClass = 'rentenlueckeWithoutPensionGap';
                }
                aDataArray.icon.inputs.iconClass = iconClass;
                aDataArray.icon.inputs.html = '';

            }

            return aDataArray;
        },

        renderDataArrayLabels: function(data) {
            const self = this;
            const aDataArray = {};

            aDataArray.labels = {};

            aDataArray.labels = {
                ...aDataArray.labels,
                ...self.renderPersonDetails(data), // set personCount, personType, personJob, personBirth
                ...self.renderTariffName(data), // set tariffName
                ...self.renderFittingTariffs(data, self.fittingTariffsWithDate), // set fittingTariffs
                ...self.renderProductSpecificLabels(data, self.sRenderType), // for product specific labels
            };

            if (data?.inputs && data.inputs?.image) {
                let imageUrl = '';
                const image = data.inputs?.image;

                switch (self.getDeviceType(self)) {
                    case 'app':
                        imageUrl = image?.urlApp ?? image?.urlMobile;
                        break;
                    case 'tabletApp':
                        imageUrl = image?.urlTabletApp ?? image?.urlDesktop;
                        break;
                    case 'mobile':
                        imageUrl = image?.urlMobile;
                        break;
                    case 'desktop':
                        imageUrl = image?.urlDesktop;
                        break;
                }

                aDataArray.labels.image = imageUrl;
            }

            // set insuredPerson
            if (data.insuredPerson) {
                aDataArray.labels.insurePersonName = self.fnValueMerge(data.insuredPerson, 'name');
            }

            // set note
            if (data.info) {
                aDataArray.labels.note = data.info;
            } else {
                aDataArray.labels.note = null;
            }

            return aDataArray;
        },

        renderPersonDetails: function(data) {
            const self = this;
            const labels = {};
            if (!data.inputs && !data.insuredPerson && !data.persons) {
                return labels;
            }

            const personsToFilter = data?.insuredPerson ?? data?.inputs?.persons ?? data?.persons;

            if (typeof personsToFilter !== 'object' || personsToFilter.length === 0) {
                return {
                    ...labels,
                    personCount: null,
                    personName: null,
                    personType: null,
                    personJob: null,
                    personBirth: null,
                    personTitle: null,
                };
            }


            let childCounter = 0;
            const persons = self.filterPersons ? self.filterPersons(personsToFilter) : personsToFilter;
            const oPersonsWithName = persons.filter(
                person => person?.firstName !== undefined && // check if key exists
                        person?.lastName !== undefined && // check if key exists
                        person.firstName && // check if !empty && !null
                        person.lastName, // check if !empty && !null
            );
            const bUseNames = (oPersonsWithName.length === persons.length);

            if (persons.length > 1) {
                let personList = '';
                let personNames = '';

                if (bUseNames) {
                    persons.forEach(function(person, iIndex) {
                        personNames += person.firstName + ' ' + person.lastName;

                        if (iIndex < persons.length - 1) {
                            personNames += ', ';
                        }
                    });

                    personList = null;
                } else {
                    personNames = null;

                    persons.map(person => person.type)
                        .forEach(function(personType) {
                            if (personType === 'Kind') {
                                childCounter++;
                            } else {
                                if (personList !== '') {
                                    personList += ', ';
                                }
                                personList += personType;
                            }
                        });

                    if (childCounter > 1) {
                        if (personList !== '') {
                            personList += ', ';
                        }
                        personList += childCounter + ' Kinder';
                    } else if (childCounter > 0) {
                        if (personList !== '') {
                            personList += ', ';
                        }
                        personList += 'Kind';
                    }
                }

                labels.personJob = null;
                labels.personBirth = null;
                labels.personCount = persons.length + ' Personen';
                labels.personName = personNames;
                labels.personType = personList;
                labels.personTitle = null;

            } else {
                labels.personCount = persons.length + ' Person';

                if (bUseNames) {
                    labels.personType = null;

                    labels.personName = persons[0].firstName + ' ' + persons[0].lastName;

                    if (self.bCommaAfterPerson) {
                        labels.personName += ', ';
                    }
                } else {
                    labels.personName = null;

                    if (self.bCommaAfterPerson) {
                        labels.personType = persons[0].type + ', ';
                    } else {
                        labels.personType = persons[0].type;
                    }
                }


                if (persons[0].job) {
                    if (self.bCommaAfterPersonJob) {
                        labels.personJob = persons[0].job + ', ';
                    } else {
                        labels.personJob = persons[0].job;
                    }
                } else {
                    labels.personJob = null;
                }

                if (persons[0].birthday) {
                    labels.personBirth = persons[0].birthday;
                } else {
                    labels.personBirth = null;
                }

                if (persons[0].title) {
                    labels.personTitle = persons[0].title;
                }
            }

            if (self.bCommaAfterPersonCount && !bUseNames) {
                labels.personCount += ', ';
            }

            return labels;
        },


        renderTariffName: function(data) {
            const labels = {};

            if (data.tariff?.name) {
                labels.tariffName = data.tariff.name;
            } else {
                labels.tariffName = null;
            }

            return labels;
        },

        renderFittingTariffs: function(data, showDate) {
            const self = this;
            const labels = {};

            const dataInputs = data?.inputs;

            if (dataInputs?.fittingTariffs) {

                labels.fittingTariffs = dataInputs.fittingTariffs;

                if (dataInputs.fittingTariffs > 1) {
                    labels.fittingTariffs += ' passende Tarife';
                } else {
                    labels.fittingTariffs += ' passender Tarif';
                }

                if (showDate && data?.time) {
                    const creationDate = self.fnUnixToDate(data.time);

                    labels.fittingTariffs += `, ${creationDate.day.number}.${creationDate.month.number}.${creationDate.year}`;
                }
            } else {
                labels.fittingTariffs = null;
            }

            return labels;
        },

        renderProductSpecificLabels: function() {
        // can be overwritten in
        // product specifc ipss logic
            const labels = {};

            return labels;
        },

        renderDataArrayToDos: function (data) {
            const self = this;
            const aDataArray = {};
            let sortPossible = true;

            aDataArray.toDos = [];

            if (!data?.inputs?.toDos) {
                return aDataArray;
            }

            for (const toDoItem of data.inputs.toDos) {
                const toDo = {
                    ...self.renderDataArrayMessage(toDoItem, 'Wir haben eine wichtige Rückfrage'),
                };
                toDo.color = toDoItem?.appearance ?? 'gray';

                toDo.url = self.bIsMobile ? toDoItem?.urlMobile : toDoItem?.urlDesktop;

                if (toDoItem?.order) {
                    toDo.order = toDoItem?.order;
                } else {
                    sortPossible = false;
                }
                aDataArray.toDos.push(toDo);
            }

            if (sortPossible) {
                aDataArray.toDos.sort((a, b) => a.order - b.order);
            }

            return aDataArray;
        },

        renderDataArrayMetaData: function(data) {
            const self = this;
            const aDataArray = {};
            const time = data.time;
            let deviceOutput = null;
            const status = data?.status ?? data?.result?.status ?? null;
            const type = (data.type) ? data.type : null;
            let textBeginning = '';
            const colorMap = {
                'grey': 'gray',
            };

            if (data.deviceOutput) {
                deviceOutput = data.deviceOutput;
            } else if (data.deviceoutput) {
                deviceOutput = data.deviceoutput;
            } else {
                deviceOutput = null;
            }

            aDataArray.metaData = {};

            // set timestamp when lastsearch or incompleteContract
            if ((type === null || type === 'incompleteContract' || type === 'rentenluecke') && time !== null) {
                const dTimestamp = new Date((time) * 1000);
                const iDay = ('0' + dTimestamp.getDate()).slice(-2);
                const iMonth = ('0' + parseInt(dTimestamp.getMonth() + 1)).slice(-2);
                const iFullDate = iDay + '.' + iMonth + '.' + dTimestamp.getFullYear();

                if ((window.c24LpTime - time) < 3600) {
                    aDataArray.metaData.timestamp = 'vor Kurzem';
                } else if ((window.c24LpTime - time) < 86400) {
                    const diffHours = Math.floor((window.c24LpTime - time) / 3600);
                    let placeholder = '';

                    if (diffHours > 1) {
                        placeholder = 'Stunden';
                    } else {
                        placeholder = 'Stunde';
                    }

                    aDataArray.metaData.timestamp = 'vor ' + diffHours + ' ' + placeholder;
                } else {
                    aDataArray.metaData.timestamp = 'am ' + iFullDate;
                }
            } else {
                aDataArray.metaData.timestamp = null;
            }

            // set deviceouput
            if (deviceOutput !== null) {
                if (deviceOutput === 'mobile') {
                    aDataArray.metaData.device = 'auf dem Handy';
                } else if (deviceOutput === 'app' || deviceOutput === 'tabletapp') {
                    aDataArray.metaData.device = 'in der App';
                } else if (deviceOutput === 'tablet') {
                    aDataArray.metaData.device = 'auf dem Tablet';
                } else {
                    aDataArray.metaData.device = 'auf dem PC/Laptop';
                }
            } else {
                aDataArray.metaData.device = null;
            }

            if (status !== null) {
                const noHtml = self.stripHtml(status.text) ?? '';

                aDataArray.metaData.statusText = self.textToHtml(noHtml);
                aDataArray.metaData.statusColor = colorMap[status.color] || status.color;
            } else {
                aDataArray.metaData.status = null;
            }

            // set type
            if (type !== null) {
                textBeginning = this.timeWordingMap[type];
            } else {
                textBeginning = 'verglichen';
            }

            aDataArray.metaData.textBeginning = textBeginning;

            // if contract don't show metadata
            if (type === 'contract') {
                aDataArray.metaData.timestamp = null;
                aDataArray.metaData.textBeginning = null;
                aDataArray.metaData.device = null;
            }

            // set contract id
            if (self.bShowContractId && data.publicId) {
                aDataArray.metaData.contractId = 'Vertrag ' + data.publicId;
            } else {
                aDataArray.metaData.contractId = null;
            }

            return aDataArray;
        },

        renderDataArrayTariffDetails: function(data) {
            const aDataArray = {};
            const self = this;
            const price = data.price ?? data.best?.price;
            let priceUnit;
            let period;
            aDataArray.tariff = {};

            if (Object.keys(data).length === 0) {
                aDataArray.tariff.count = null;

                aDataArray.tariff.price = null;

                aDataArray.tariff.period = null;

                return aDataArray;
            }
            // set period
            if (data.period) {
                period = data.period;
            } else if (data.best && data.best.period) {
                period = data.best.period;
            } else {
                period = null;
            }

            // set count
            if (data.count || data.best?.count) {
                const count = data.count ?? data.best.count;
                if (data.count === 1) {
                    aDataArray.tariff.count = count + ' Tarif ab';
                } else {
                    aDataArray.tariff.count = count + ' Tarife ab';
                }
            } else {
                aDataArray.tariff.count = 'ab';
            }

            // set priceUnit
            if (data.priceUnit != null) {
                priceUnit = data.priceUnit;
            } else if (data.best && data.best.priceUnit) {
                priceUnit = data.best.priceUnit;
            } else {
                priceUnit = self.defaultPriceUnit;
            }
            // set price
            aDataArray.tariff.price = price ? self.formatPrice(price, priceUnit) : null;

            // set period
            if (period && aDataArray.tariff.price) {
                aDataArray.tariff.period = self.periodMap[period.toLowerCase()];
            } else {
                aDataArray.tariff.period = null;
            }

            return aDataArray;
        },

        renderDataArrayRatingTags: function(data) {
            const self = this;
            const aDataArray = {};

            aDataArray.ratingTags = [];

            // set rating tags
            if (data.ratingTags) {
                if (data.ratingTags.length === 0) {
                    return aDataArray;
                }

                for (const tag of data.ratingTags) {
                    const normalizedTag = {};

                    if (!tag.label || !self.tagsRatingMap[tag.rating]?.text || !self.tagsRatingMap[tag.rating]?.color) {
                        return;
                    }

                    normalizedTag.tagLabel = tag.label;
                    normalizedTag.tagRating = self.tagsRatingMap[tag.rating]?.text;
                    normalizedTag.color = self.tagsRatingMap[tag.rating]?.color;

                    aDataArray.ratingTags.push(normalizedTag);
                }
            // support old syntax
            } else if (data.servicesRating) {
                const normalizedTag = {};

                if (!self.tagsRatingMap[data.servicesRating]?.text || !self.tagsRatingMap[data.servicesRating]?.color) {
                    return;
                }

                normalizedTag.tagLabel = 'Leistungen';
                normalizedTag.tagRating = self.tagsRatingMap[data.servicesRating]?.text;
                normalizedTag.color = self.tagsRatingMap[data.servicesRating]?.color;

                aDataArray.ratingTags.push(normalizedTag);
            }

            return aDataArray;
        },

        renderDataArrayCta: function(dataCta) {
            const self = this;
            const aDataArray = {};
            let urlDesktop;
            let urlMobile;

            aDataArray.cta = {
                'primary': null,
                'secondary': null,
                'tertiary': null,
                'quaternary': null,
            };

            if (self.sRenderType === 'lastSearches') {
                if (self.bIsApp) {
                // app & tablet app
                    if (dataCta.urlTabletApp) {
                        urlDesktop = dataCta.urlTabletApp;
                    } else {
                        urlDesktop = dataCta.urlDesktop;
                    }

                    if (dataCta.urlApp) {
                        urlMobile = dataCta.urlApp;
                    } else {
                        urlMobile = dataCta.urlMobile;
                    }
                } else {
                // desktop & mobile
                    urlDesktop = dataCta.urlDesktop;
                    urlMobile = dataCta.urlMobile;
                }

                aDataArray.cta.primary = {
                    'text': dataCta.text,
                    'urlDesktop': urlDesktop,
                    'urlMobile': urlMobile,
                };
            } else {
                $.each(dataCta, function(key, value) {
                    if (self.bIsApp) {
                    // app & tablet app
                        if (value.urlTabletApp) {
                            urlDesktop = value.urlTabletApp;
                        } else {
                            urlDesktop = value.urlDesktop;
                        }

                        if (value.urlApp) {
                            urlMobile = value.urlApp;
                        } else {
                            urlMobile = value.urlMobile;
                        }
                    } else {
                    // desktop & mobile
                        urlDesktop = value.urlDesktop;
                        urlMobile = value.urlMobile;
                    }


                    aDataArray.cta[value.type] = {
                        'text': value.text,
                        'urlDesktop': urlDesktop,
                        'urlMobile': urlMobile,
                    };
                });
            }

            return aDataArray;
        },

        renderDataArrayLinking: function(data) {
            const aDataArray = {};
            let urlDelete = null;

            if (data && data.url_delete) {
                urlDelete = data.url_delete;
            } else if (data && data.urlDelete) {
                urlDelete = data.urlDelete;
            }

            if (urlDelete === null) {
                return aDataArray;
            }

            aDataArray.urlDelete = urlDelete;

            return aDataArray;
        },

        renderDataArrayConsultant: function(data) {
            const self = this;
            const aDataArray = {};
            const consultantSubheadText = {
                'male': 'Ihr persönlicher Berater',
                'female': 'Ihre persönliche Beraterin',
            };

            let consultantImageUrl = null;
            let consultantProperties = self.renderPersonDetails(data);
            const consultantGender = data?.persons[0]?.gender || 'male';

            aDataArray.consultant = {};

            switch (self.getDeviceType(self)) {
                case 'app':
                    consultantImageUrl = data?.image?.urlApp ?? data?.image?.urlMobile;
                    break;
                case 'tabletApp':
                    consultantImageUrl = data?.image?.urlTabletApp ?? data?.image?.urlDesktop;
                    break;
                case 'mobile':
                    consultantImageUrl = data?.image?.urlMobile;
                    break;
                case 'desktop':
                    consultantImageUrl = data?.image?.urlDesktop;
                    break;
            }

            aDataArray.consultant.consultantImage = consultantImageUrl ?? null;
            aDataArray.consultant.consultantName = consultantProperties.personName ?? null;
            aDataArray.consultant.consultantJob = consultantProperties.personJob ?? null;

            if (self.bUseTilesLayout) {
                aDataArray.consultant.consultantSubhead = consultantSubheadText[consultantGender] ?? null;
            }

            if (data?.phone || data?.phoneNumber) {
                aDataArray.consultant.consultantPhone = data?.phone ?? data?.phoneNumber;
            }
            if (data?.email) {
                aDataArray.consultant.consultantEmail = data?.email;
            }
            if (data?.times) {
                aDataArray.consultant.consultantTimes = data?.times;
            }


            return aDataArray;
        },

        renderDataArrayTileHeadline: function(sRenderType, data) {
            const aDataArray = {};
            const self = this;

            aDataArray.tileConfig = {};

            if (self.renderDataArrayProductSpecificTileHeadline(sRenderType, data) !== false) {
                aDataArray.tileConfig.headline = self.renderDataArrayProductSpecificTileHeadline(sRenderType, data);

                return aDataArray;
            }

            aDataArray.tileConfig.headline = self.tileHeadlineMap[sRenderType] ?? null;

            if (sRenderType === 'staticTile' && self.bIsMobile) {
                aDataArray.tileConfig.headline = 'Versicherung nicht über uns abgeschlossen?<br>Jetzt Vertrag hinzufügen und sparen!';
            }

            if (sRenderType === 'promotion') {
                aDataArray.tileConfig.headline = data.headline.text ?? self.tileHeadlineMap[sRenderType] ?? null;
                aDataArray.tileConfig.subheadline = data.headline.subtext ?? null;
            }

            if (sRenderType === 'appointment') {
                if (data?.appointmentTime) {
                    aDataArray.tileConfig.headline = 'Ihr Beratungstermin';
                } else if (self.bIsMobile) {
                    aDataArray.tileConfig.headline = 'Tipp: Termin vereinbaren';
                }
            }

            if (sRenderType === 'productSpecificTile') {
                aDataArray.tileConfig.headline = data.headline?.text ?? self.tileHeadlineMap[sRenderType] ?? null;
            }

            return aDataArray;
        },

        renderDataArrayProductSpecificTileHeadline: function() {
            // can be overwritten in
            // product specifc ipss logic

            return false;
        },

        cleanUpMessage: function(data, fallbackMessage = '') {
            const self = this;
            const paragraphCollection = [];

            if (!data || !data?.body || typeof data.body !== 'object') {
                paragraphCollection.push(fallbackMessage);
            } else {
                for (const paragraph of data.body) {
                    const noHtml = self.stripHtml(paragraph) ?? '';

                    const html = self.textToHtml(noHtml);

                    paragraphCollection.push(html);
                }
            }

            return paragraphCollection;
        },

        renderDataArrayMessage: function(data, fallbackMessage) {
            const self = this;
            const aDataArray = {};

            aDataArray.message = {};

            aDataArray.message.messageText = self.cleanUpMessage(data, fallbackMessage) ?? [fallbackMessage];

            return aDataArray;
        },

        renderDataArraySalutation: function(data) {
            const aDataArray = {};

            aDataArray.salutation = {};
            const genderMap = {
                'male': 'Herr',
                'female': 'Frau',
            };

            const message = data?.message;
            const salutationPrefix = message?.salutation || 'Guten Tag';
            const person = message?.persons?.[0];
            const hasValidGender = person?.gender && genderMap[person.gender];

            const setAllToNull = {
                'salutationPrefix': salutationPrefix,
                'customerTitle': null,
                'customerFirstName': null,
                'customerLastName': null,
            };

            if (!message || !person) {
                aDataArray.salutation = setAllToNull;

                return aDataArray;
            }

            if (!hasValidGender) {
                aDataArray.salutation.customerTitle = null;
            } else {
                aDataArray.salutation.customerTitle = genderMap[person.gender] + ' ';
            }

            if (!aDataArray.salutation.customerTitle && person.firstName) {
                aDataArray.salutation.customerFirstName = person.firstName || null;
            } else {
                aDataArray.salutation.customerFirstName = null;
            }

            if (!person.lastName) {
                if (person.firstName) {
                    aDataArray.salutation.customerTitle = null;
                    aDataArray.salutation.customerLastName = null;
                    aDataArray.salutation.customerFirstName = person.firstName || null;
                } else {
                    aDataArray.salutation = setAllToNull;
                }

                return aDataArray;
            } else {
                if (!hasValidGender && !aDataArray.salutation.customerFirstName) {
                    aDataArray.salutation.customerLastName = null;
                } else {
                    aDataArray.salutation.customerLastName = ' ' + person.lastName;
                }
            }

            aDataArray.salutation.salutationPrefix = salutationPrefix;

            if (aDataArray.salutation.customerLastName || aDataArray.salutation.customerFirstName) {
                aDataArray.salutation.salutationPrefix += ' ';
            }

            return aDataArray;
        },

        renderDataArrayTimeToDate: function(data) {
            const self = this;
            const aDataArray = {};
            let dateDetailed = {};

            aDataArray.date = {
                'dayOfWeek': null,
                'day': null,
                'time': null,
            };

            if (self.fnIsoToDate(data)) {
                dateDetailed = self.fnIsoToDate(data);
            } else if (self.fnUnixToDate(data)) {
                dateDetailed = self.fnUnixToDate(data);
            } else {
                return aDataArray;
            }

            aDataArray.date = {
                'dayOfWeek': dateDetailed.day.name + ', ',
                'day': dateDetailed.day.number + '.' + dateDetailed.month.number + '.' + dateDetailed.year,
                'time': dateDetailed.hours + ':' + dateDetailed.minutes + ' Uhr',
            };

            return aDataArray;
        },

        renderElement: function(element, data) {
            const self = this;

            if (data.categoryType) {
                self.renderCategoryType(element, data);
            }

            if (data.icon) {
                self.renderIcons(element, data);
            }

            if (data.labels) {
                self.renderLabels(element, data);
            }

            if (data.toDos) {
                self.renderToDos(element, data);
            }

            if (data.metaData) {
                self.renderMetaData(element, data);
            }

            if (data.ratingTags) {
                self.renderRatingTags(element, data.ratingTags);
            }

            if (data.tariff) {
                self.renderTariffDetails(element, data);
            }

            if (data.cta) {
                self.renderCta(element, data);
            }

            self.renderLinking(element, data);

            if (data.consultant) {
                self.renderConsultant(element, data.consultant);
            }

            if (data.message) {
                self.renderMessage(element, data.message, data.date);
            }

            if (self.bUseTilesLayout) {
                self.renderTileHeadline(element, data.tileConfig, data.date);
            }

            if (data.salutation) {
                self.renderSalutation(element, data.salutation);
            }

            if (data.date) {
                self.renderDate(element, data.date);
            }

            // waite till showIpssTeaser is finished
            $.when(self.renderingDone).done(function() {
                if (data.tooltips) {
                    self.renderTooltips(element, data);
                }
            });
        },

        renderCategoryType: function(element, data) {
            $(element).data('category', data.categoryType);
        },

        renderIcons: function(element, data) {
            const self = this;

            if (data.icon) {
                $.each(data.icon, function(key, value) {
                    const $iconContainer = $('.iconContainer.icon' + self.capitalizeFirstLetter(key), element);
                    if (value.iconKey) {
                        $iconContainer.html(value.html).attr('data-type', value.iconKey);
                    } else if (Array.isArray(value.html)) {
                        $iconContainer.html('');

                        for (const iconUrl of value.html) {
                            $('<div class="insurerIcon">').css({
                                'background-image': 'url("' + iconUrl + '")',
                            }).appendTo($iconContainer);
                        }
                    } else if (value.html) {
                        $iconContainer.css({
                            'background-image': 'url("' + value.html + '")',
                        });
                    }
                    if (value.iconClass) {
                        $iconContainer.addClass(value.iconClass);
                    }
                });
            } else {
                $('.iconContainer', element).remove();
            }
        },

        renderLabels: function(element, data) {
            $.each(data.labels, function(key, value) {
                if (value != null) {
                    if (key === 'image') {
                        if (typeof value === 'object') {

                            if (value.default) {
                                $('.' + key, element).css({
                                    '--bgImageUrl': 'url("' + value.default + '")',
                                });
                            }

                            if (value.highRes) {
                                $('.' + key, element).css({
                                    '--bgImageUrlHighRes': 'url("' + value.highRes + '")',
                                });
                            }
                        } else {
                            $('.' + key, element).css({
                                '--bgImageUrl': 'url("' + value + '")',
                            });
                        }
                    } else {
                        $('.' + key, element).html($.parseHTML(value));
                    }
                } else {
                    if (key === 'tariffName') {
                        $('.tariffSeparator', element).remove();
                    }
                    $('.' + key, element).remove();
                    $('.' + key + 'Container', element).remove();
                }
            });
        },

        renderToDos: function(element, data) {
            if (!data?.toDos || data.toDos.length === 0) {
                $('.toDosContainer', element).remove();
            }

            const blueprint = $('.toDosContainer .toDosItem', element).clone();

            $('.toDosItem', element).remove();

            for (const toDo of data.toDos) {
                const newToDoItem = blueprint.clone();

                for (const key in toDo) {
                    if (key === 'color') {
                        newToDoItem.addClass(toDo[key]);

                        continue;
                    }

                    if (key === 'message') {
                        let html = '';

                        for (const paragraph of toDo[key].messageText) {
                            if (paragraph) {
                                html += '<p>' + paragraph + '</p>';
                            }
                        }

                        $('.' + key, element).html(html);

                        newToDoItem.children('.messageText').html(html);
                    }

                    if (key === 'url' && toDo[key] !== undefined) {
                        const urlElement = $('<a>').attr('href', toDo[key]).addClass('messageText');
                        urlElement.html(newToDoItem.find('.messageText').html());
                        newToDoItem.find('.messageText').replaceWith(urlElement);
                    }
                }

                newToDoItem.appendTo($('.toDosContainer', element));
            }
        },

        renderMetaData: function(element, data) {
            const self = this;
            const bAtLeastTwo = function(aCollection) {
                if (aCollection[0] && (aCollection[1] || aCollection[2]) || (aCollection[1] && aCollection[2])) {
                    return true;
                }

                return false;
            };

            if (self.bIsMobile && !bAtLeastTwo([
                data.metaData.timestamp,
                data.metaData.textBeginning,
                data.metaData.device,
            ])) {
                $('.metaData', element).remove();
            }

            $.each(data.metaData, function(key, value) {
                if (key !== 'status' && key.match('^status')) {
                    if (key.match('Text$')) {
                        $('.status', element).html(value);
                    }
                    if (key.match('Color$')) {
                        $('.status', element).addClass(value);
                    }
                    return;
                }

                if (value != null) {
                    $('.' + key, element).text(value);
                } else {
                    $('.' + key, element).remove();
                    $('.' + key + 'Container', element).remove();
                }
            });
        },

        renderRatingTags: function(element, data) {

            if (data.length === 0) {
                $('.ratingTagsContainer', element).remove();

                return;
            }

            const blueprint = $('.ratingTagsContainer .tagItem', element).clone();

            $('.tagItem', element).remove();

            for (const tag of data) {
                const newTagItem = blueprint.clone();

                for (const key in tag) {
                    if (key === 'color') {
                        newTagItem.children('.tagRating').addClass(tag[key]);

                        continue;
                    }

                    newTagItem.children('.' + key).text(tag[key]);
                }

                newTagItem.appendTo($('.ratingTagsContainer', element));
            }
        },

        renderTariffDetails: function(element, data) {
            const self = this;

            $.each(data.tariff, function(key, value) {
                if (value === null) {
                    $('.tariff' + self.capitalizeFirstLetter(key), element).remove();
                } else {
                    $('.tariff' + self.capitalizeFirstLetter(key), element).text(value);
                }
            });
        },

        renderCta: function(element, data) {
            const self = this;

            if (self.bIsMobile) {

                let sLinkUrl = '';
                let sLinkText = '';

                if (data.cta.primary) {
                    sLinkUrl = data.cta.primary.urlMobile;
                    sLinkText = data.cta.primary.text;
                } else if (data.cta.secondary) {
                    sLinkUrl = data.cta.secondary.urlMobile;
                    sLinkText = data.cta.secondary.text;
                } else if (data.cta.tertiary) {
                    sLinkUrl = data.cta.tertiary.urlMobile;
                    sLinkText = data.cta.tertiary.text;
                } else if (data.cta.quaternary) {
                    sLinkUrl = data.cta.quaternary.urlMobile;
                    sLinkText = data.cta.quaternary.text;
                }

                $('.js24ButtonCompare', element).attr('href', sLinkUrl);
                $('.js24ButtonCompare', element).attr('aria-label', sLinkText);

                element.data('linking', sLinkUrl);

                if ($('.ctaButtonContainer .js24ButtonCompare.primary', element)) {
                    $('.ctaButtonContainer .js24ButtonCompare.primary', element).html(sLinkText);
                }

            } else {
                $.each(data.cta, function(key, value) {
                    const $button = $('.js24ButtonCompare.' + key, element);
                    if (value == null) {
                        if (key === 'primary') {
                            $('.js24ButtonCompare.' + key + ' + .note', element).remove();
                        }

                        $button.remove();
                    } else {

                        $button.attr('href', value.urlDesktop).html(value.text);

                        if (key === 'primary' && ((element.hasClass('lastSearches') && !self.bUseTilesLayout) || (self.bWholeTileClickable && self.bUseTilesLayout))) {
                            element.data('linking', value.urlDesktop).css({
                                cursor: 'pointer',
                            });
                        }
                    }
                });
            }
        },

        renderLinking: function(element, data) {
            const self = this;

            self.rederLinkingTooltip(element, data);

            self.renderLinkingButtons(element);

            self.renderLinkingDelete(element, data);
        },

        rederLinkingTooltip: function(element) {
            $('.c24Tooltip , .js24VsIpssTooltip', element).on('click', function(e) {
                e.stopPropagation();
                return false;
            });
        },

        renderLinkingButtons: function(element) {
            const self = this;
            $('.primary, .secondary, .tertiary, .quaternary', element).on('click', function(e) {
                e.stopPropagation();

                $(this)
                    .trigger('c24Tracking')
                    .trigger('c24Spinner');
            });

            if (!self.bUseTilesLayout || self.bWholeTileClickable) {
                element.on('click', function(e) {

                    if (e.target.tagName.toLowerCase() !== 'a') {
                        e.preventDefault();
                    }

                    if ($(e.target).closest('a.messageText').length > 0) {
                        window.location.href = $(e.target).closest('a.messageText').attr('href');

                        return false;
                    }

                    if (e.target.tagName.toLowerCase() === 'a') {

                        return true;
                    }

                    const dataLinking = $(this).data('linking');

                    if (dataLinking != null) {
                        window.location.href = dataLinking;
                    }
                });
            }
        },

        renderLinkingDelete: function(element, data) {
            const self = this;

            if (self.bIsMobile && !self.bUseTilesLayout) {
                $('.metaData', element).on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if ($(this).find('.delete').length < 1) {
                        return false;
                    }

                    const jSelf = $(this);

                    if (jSelf.data('deletelink')) {
                        self.removeIpssItem(jSelf, self);
                    }

                    return false;
                });

            } else {
                $('.delete', element).on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const jSelf = $(this);
                    self.removeIpssItem(jSelf, self);

                    return false;
                });
            }

            const metaDataContainer = $('.metaData', element);

            if (data.urlDelete != null) {
                if (self.bIsMobile && !self.bUseTilesLayout) {
                    metaDataContainer.data('deletelink', data.urlDelete);
                } else {
                    if ($('.delete', metaDataContainer).length) {
                        $('.delete', metaDataContainer).data('deletelink', data.urlDelete);
                    } else {
                        $('.delete', element).data('deletelink', data.urlDelete);
                    }
                }
            } else {
                if (self.bIsMobile && !self.bUseTilesLayout) {
                    $('.delete', metaDataContainer).remove();
                } else {
                    if ($('.delete', metaDataContainer).length) {
                        $('.delete', metaDataContainer).remove();
                    } else {
                        $('.delete', element).remove();
                    }
                }
            }
        },

        renderConsultant: function(element, data) {
            for (const [key, value] of Object.entries(data)) {
                if (value === null) {
                    $('.' + key, element).remove();

                    continue;
                }

                if (key === 'consultantPhone') {
                    $('.' + key, element).attr('href', 'tel:' + value.replace(/\D/g, ''));
                }

                if (key === 'consultantImage') {
                    if (typeof value === 'object') {

                        if (value.default) {
                            $('.' + key, element).css({
                                '--bgImageUrl': 'url("' + value.default + '")',
                            });
                        }

                        if (value.highRes) {
                            $('.' + key, element).css({
                                '--bgImageUrlHighRes': 'url("' + value.highRes + '")',
                            });
                        }
                    } else {
                        $('.' + key, element).css({
                            '--bgImageUrl': 'url("' + value + '")',
                        });
                    }
                } else {
                    $('.' + key, element).html(value);
                }

            }
        },
        renderMessage: function(...args) {
            const [element, data] = args;
            for (const [key, value] of Object.entries(data)) {
                if (value === null) {
                    $('.' + key, element).remove();

                    continue;
                }

                if (key === 'messageText') {
                    let html = '';

                    for (const paragraph of value) {
                        if (paragraph) {
                            html += '<p>' + paragraph + '</p>';
                        }
                    }

                    $('.' + key, element).html(html);
                } else {

                    $('.' + key, element).html(value);
                }
            }
        },

        renderTileHeadline: function(element, data) {
            const self = this;

            for (const [key, value] of Object.entries(data)) {
                if (value === null) {
                    $('.tile' + self.capitalizeFirstLetter(key), element).remove();

                    continue;
                }

                $('.tile' + self.capitalizeFirstLetter(key), element).html(value);
            }
        },

        renderSalutation: function(element, data) {
            for (const [key, value] of Object.entries(data)) {
                if (value === null) {
                    $('.' + key, element).remove();

                    continue;
                }

                $('.' + key, element).html(value);
            }
        },

        renderDate: function(element, data) {

            if (Object.entries(data).filter(([, value]) => value !== null).length === 0) {
                $('.dateContainer', element).remove();

                return;
            }

            for (const [key, value] of Object.entries(data)) {
                if (value === null) {
                    $('.' + key, element).remove();

                    continue;
                }

                $('.' + key, element).html(value);
            }
        },

        renderTooltips: function(element, data) {

            if (data.tooltips.labels) {
                data.tooltips = data.tooltips.labels;
            }

            $.each(data.tooltips, function(key, value) {
                if (value != null) {
                    $('.c24TooltipPopup .' + key, element).html($.parseHTML(value));
                } else {
                    $('.c24TooltipPopup .' + key, element).remove();
                }
            });

            // create tooltip
            if (!window.c24LpIsMobile) {
                const $el = $('.c24Tooltip', element);
                const ac = $('#c24-content');
                let arrowPosition = 'left center';
                let parentPosition = 'right center';

                if ($el.offset().left + ($el.width() / 2) > ac.offset().left + (ac.width() / 2)) {
                    arrowPosition = 'right center';
                    parentPosition = 'left center';
                }

                $('.c24Tooltip', element).qtip({
                    content: {
                        text: $('.c24TooltipPopup', element).html(),
                        button: (window.c24LpNotPinnedQtip ? null : 'Schließen'),
                    },
                    style: {
                        classes: 'ipssTooltip' + (window.c24LpNotPinnedQtip ? '' : ' closable'),
                        tip: {
                            border: 1,
                            width: 16,
                            height: 9,
                        },
                    },
                    show: {
                        event: (window.c24LpNotPinnedQtip ? 'mouseenter' : 'click focus'),
                    },
                    hide: {
                        event: (window.c24LpNotPinnedQtip ? 'mouseleave focusout' : ''),
                        fixed: true,
                        delay: 500,
                    },
                    position: {
                        viewport: $('html'),
                        // Position of the arrow
                        my: arrowPosition,
                        // Position relative to the parent element
                        at: parentPosition,
                        adjust: {
                            method: (((parentPosition == 'left center' || parentPosition == 'right center') && $(this).closest('.qtipWrapper')) ? 'none none' : 'shift flip'),
                        },
                    },
                    events: {
                        render: function(event, api) {
                            window.c24OnRenderQtip(event, api);
                        },

                        move: function(event, api, position) {
                            window.c24RepositionQTip(api, position);
                        },
                    },
                });
            } else {
                $('.js24VsIpssTooltip', element).click(function () {
                    const html = $('.c24TooltipPopup', element).html();
                    window.c24LpOpenPopup(html);
                });
            }
        },
        removeIpssItemWithoutStaticTileInFlow: function(currentElement, outerSelf, bDeleteAll) {
            const jSelf = currentElement;
            const ipssItem = jSelf.closest('.ipssItem');
            const deleteUrl = jSelf.data('deletelink');

            const category = ipssItem.data('category');

            let itemWrapper = $(jSelf, outerSelf.domContext).closest('.ipssItemWrapper');

            if (outerSelf.bIsMobile && outerSelf.bUseTilesLayout) {
                const $tabContentBox = $('.cssTabContentBox', outerSelf.domContext);
                if (category !== 'contract' && category !== 'staticTile' ) {
                    itemWrapper = $tabContentBox;
                }

                const $nonContractsContainer = $('.ipssItemWrapper.nonContractsContainer', outerSelf.domContext);
                const isOffersContainerEmpty = !$tabContentBox.children('.offersContainer').length || !$tabContentBox.children($nonContractsContainer.selector).length;
                const isIncompleteContractsContainerEmpty = !$tabContentBox.children('.incompleteContractsContainer').length || !$tabContentBox.children($nonContractsContainer.selector).length;

                if ((category === 'incompleteContract' && isIncompleteContractsContainerEmpty) || (category === 'offer' && isOffersContainerEmpty)) {
                    itemWrapper = $(jSelf, outerSelf.domContext).closest($nonContractsContainer);
                }
            }

            let prevHeadline = outerSelf.bUseTilesLayout && !outerSelf.bIsMobile ? undefined : itemWrapper.prev('.ipssHeadline');

            if (category === 'staticTile') {
                prevHeadline = itemWrapper.children('.ipssHeadline');
            }

            const visibleNeighbours = $(Array.from(itemWrapper.find('.ipssItem')).filter(el => el !== ipssItem[0]));
            const countVisibleNeighbours = visibleNeighbours.length;

            let amountStaticTileItems = $('.staticTileContainer', outerSelf.domContext).find('.ipssItem').length;

            $.ajax({
                url: deleteUrl,
                type: outerSelf.sDeleteMethod,
                xhrFields: {
                    withCredentials: true,
                },
                cache: false,
            });

            if (!bDeleteAll) {
                $(jSelf, outerSelf.domContext).trigger('c24IpssDelete');
            }

            // delete whole section/category
            if (bDeleteAll) {
                itemWrapper.stop().fadeOut(600, function() {
                    $(this).remove();

                    outerSelf.itemDeleteFollowUp();
                });

                // delete associated headline
                prevHeadline?.stop().fadeOut(600, function() {
                    $(this).remove();
                });
            } else {
                // delete whole section/category if last item got deleted
                if (countVisibleNeighbours === 0) {
                    // delete associated headline
                    prevHeadline?.stop().fadeOut(600, function() {
                        $(this).remove();
                    });

                    itemWrapper.children('.deleteAll').stop().fadeOut(600);

                    // place static tile in the middle if it's the last item
                    if (!ipssItem.hasClass('staticTile')) {

                        if (outerSelf.bUseTilesLayout && $('.ipssItemWrapper:not(.staticTileContainer)', outerSelf.domContext).length === 1) {

                            $('.staticTileSeparator', outerSelf.domContext).stop().fadeOut(600, function() {
                                outerSelf.staticTileOnlyLayout();
                            });
                        }
                    }

                    ipssItem.stop().fadeOut(600, function() {
                        itemWrapper.remove();

                        outerSelf.itemDeleteFollowUp();

                        // recognize if it's a static tile
                        if ($(this).hasClass('staticTile') && amountStaticTileItems === 1) {
                            outerSelf.$ac.removeClass('withStaticTile');
                        }

                        outerSelf.removeChip(category);
                    });
                } else {
                    // delete single item
                    ipssItem.stop().fadeOut(600, function() {
                        $(this).remove();

                        if (countVisibleNeighbours === 1) {
                            outerSelf.chipLabelToSingular(category);
                        }
                        outerSelf.itemDeleteFollowUp();

                    });
                }
            }

        },

        removeIpssItemWithStaticTileInFlow: function(currentElement, outerSelf, bDeleteAll) {
            const jSelf = currentElement;
            const ipssItem = jSelf.closest('.ipssItem');
            const deleteUrl = jSelf.data('deletelink');

            const category = ipssItem.data('category');
            const staticTileList = $('.staticTileInFlowContainer', outerSelf.domContext);
            const isStaticTile = ipssItem.hasClass('staticTile');
            let isStaticTileListEmpty = staticTileList.length === 0;

            let itemWrapper = $(jSelf, outerSelf.domContext).closest('.ipssItemWrapper');
            const wrapperClass = itemWrapper.attr('class').split(/\s+/).filter(cls => cls !== 'ipssItemWrapper').join(' ');
            const identicalWrappers = $(`.ipssItemWrapper.${wrapperClass}`, outerSelf.domContext);
            if (identicalWrappers.length > 1) {
                itemWrapper = identicalWrappers.first();
                identicalWrappers.each(function(index) {
                    if (index !== 0) {
                        const children = $(this).children('li').detach();
                        itemWrapper.append(children);
                        $(this).remove();
                    }
                });
            }

            if (outerSelf.bIsMobile && outerSelf.bUseTilesLayout) {
                const $tabContentBox = $('.cssTabContentBox', outerSelf.domContext);
                if (category !== 'contract' && category !== 'staticTile' ) {
                    itemWrapper = $tabContentBox;
                }

                const $nonContractsContainer = $('.ipssItemWrapper.nonContractsContainer', outerSelf.domContext);
                const isOffersContainerEmpty = !$tabContentBox.children('.offersContainer').length || !$tabContentBox.children($nonContractsContainer.selector).length;
                const isIncompleteContractsContainerEmpty = !$tabContentBox.children('.incompleteContractsContainer').length || !$tabContentBox.children($nonContractsContainer.selector).length;

                if ((category === 'incompleteContract' && isIncompleteContractsContainerEmpty) || (category === 'offer' && isOffersContainerEmpty)) {
                    itemWrapper = $(jSelf, outerSelf.domContext).closest($nonContractsContainer);
                }
            }

            let prevHeadline = outerSelf.bUseTilesLayout && !outerSelf.bIsMobile ? undefined : itemWrapper.prev('.ipssHeadline');

            if (category === 'staticTile') {
                prevHeadline = itemWrapper.children('.ipssHeadline');
            }

            const visibleNeighbours = $(Array.from(itemWrapper.find('.ipssItem')).filter(el => el !== ipssItem[0]));
            const countVisibleNeighbours = visibleNeighbours.length;

            let amountStaticTileItems = $(staticTileList).find('.ipssItem').length;


            $.ajax({
                url: deleteUrl,
                type: outerSelf.sDeleteMethod,
                xhrFields: {
                    withCredentials: true,
                },
                cache: false,
            });

            if (!bDeleteAll) {
                $(jSelf, outerSelf.domContext).trigger('c24IpssDelete');
            }

            // delete whole section/category
            if (bDeleteAll) {

                $(itemWrapper).remove();
                outerSelf.itemDeleteFollowUp();

                // delete associated headline
                $(prevHeadline).remove();

            } else {
                // delete whole section/category if last item got deleted
                if (countVisibleNeighbours === 0) {

                    // delete associated headline
                    $(prevHeadline).remove();


                    itemWrapper.children('.deleteAll').stop().fadeOut(600);


                    itemWrapper.remove();

                    outerSelf.itemDeleteFollowUp();

                    // recognize if it's a static tile
                    if (isStaticTile && amountStaticTileItems === 1) {
                        if (!outerSelf.bIsMobile && outerSelf.bUseTilesLayout) {
                            staticTileList.detach();
                            isStaticTileListEmpty = true;
                        }
                    }

                    outerSelf.removeChip(category);

                } else {
                    // delete single item
                    $(ipssItem).remove();

                    if (countVisibleNeighbours === 1) {
                        outerSelf.chipLabelToSingular(category);
                    }
                    outerSelf.itemDeleteFollowUp();

                }
            }

            if (outerSelf.bUseTilesLayout && !outerSelf.bIsMobile && !isStaticTileListEmpty) {

                const {
                    sortedLis, elementsMap,
                } = outerSelf.sortTiles();
                const position = outerSelf.determineStaticTilePosition(sortedLis);

                outerSelf.renderSortedTilesWithStatic(elementsMap, position, staticTileList);

                if (outerSelf.showFilterChips) {
                    outerSelf.registerTilesFilterEvent();
                }

            }
        },

        removeIpssItem: function(currentElement, outerSelf, bDeleteAll) {
            if (!outerSelf.isStaticTileInFlow) {
                outerSelf.removeIpssItemWithoutStaticTileInFlow(currentElement, outerSelf, bDeleteAll);
            } else {
                outerSelf.removeIpssItemWithStaticTileInFlow(currentElement, outerSelf, bDeleteAll);
            }

        },

        chipLabelToSingular: function(category) {
            const doesChipLabelExist = this.filterChipLabelMap[category];
            if (typeof category === 'undefined' || !doesChipLabelExist) {
                return;
            }

            const self = this;
            category = category === 'contract' ? 'contracts' : category;

            $(`.${category}Chip .ipssFilterItem`, self.domContext).text(`${self.filterChipLabelMap[category].singular ?? ''}`);
        },

        removeChip: function(category) {
            category = category === 'contract' ? 'contracts' : category;
            if (typeof category === 'undefined') {
                return;
            }
            const self = this;
            const $itemsWrapper = $('.ipssItemWrapper:not(.staticTileContainer, .staticTileInFlowContainer, .promotionsContainer, .consultantsContainer)', self.domContext);
            let areRemainWrappersOfSameCategory = false;
            let itemWrapperClass = $itemsWrapper.first().attr('class');
            $itemsWrapper.each((index, itemWrapper) => {
                if ($(itemWrapper).hasClass(itemWrapperClass) && index !== 0) {
                    areRemainWrappersOfSameCategory = true;
                } else {
                    itemWrapperClass = $(itemWrapper).attr('class');
                }
            });

            $(`.${category}Chip`, self.domContext).remove();

            if ($('.ipssFilterBox', self.domContext).length < 3 && ($itemsWrapper.length < 2 || areRemainWrappersOfSameCategory)) {
                if (!$('.showAllChip', self.domContext).children('.ipssFilterItem').hasClass('active')) {
                    $('.showAllChip .ipssFilterItem', self.domContext).trigger('click');
                }
                $('.showAllChip', self.domContext).remove();

                $('.ipssFilterItem', self.domContext).trigger('click');
            } else {
                $('.showAllChip .ipssFilterItem', self.domContext).trigger('click');
            }
        },

        itemDeleteFollowUp: function() {
            const self = this;

            const contentBoxNonContracts = $('.cssTabContentBox[id*=lastSearches]', self.domContext);
            const contentBoxContracts = $('.cssTabContentBox[id*=contracts]', self.domContext);
            let amountIpssItems = $('.box24VsIpss', self.domContext).find('.ipssItem').length;

            if (self.bIsMobile) {
                const amountIpssStaticItems = $('.staticTileContainer', self.domContext).children('.ipssItem').length;
                amountIpssItems = amountIpssItems + amountIpssStaticItems;
            }

            if (amountIpssItems === 0) {
                self.showDefaultTeaser(self);

                return;
            }

            if (self.bUseTilesLayout) {
                self.checkSliderArrowsVisibility();

                return;
            }

            if (contentBoxContracts.find('.ipssItem').length === 0 && contentBoxContracts.find('.missingInfo').length === 0) {
                self.addMissingInfo(contentBoxContracts, 'contracts');
            }

            if (contentBoxNonContracts.find('.ipssItem').length === 0 && contentBoxNonContracts.find('.missingInfo').length === 0) {
                self.addMissingInfo(contentBoxNonContracts, 'nonContracts');
            }
        },

        staticTileOnlyLayout: function() {
            const self = this;

            $('.ipssFilterContainer', self.domContext).remove();

            $('.staticSliderNav', self.domContext).remove();
            $('.staticTileSeparator', self.domContext).remove();

            $('.js24VsIpss', self.domContext).css({
                'grid-template-columns': '21px var(--tilesWidth) 21px',
            });

            $('.staticTileBox', self.domContext).css({
                'grid-column': '2 / 3',
                'margin-left': '0',
                'margin-right': '0',
            });

            if (self.isStaticTileInFlow) {
                const staticTileContainer = $('.staticTileContainer', self.domContext);
                $(staticTileContainer).append($('.staticTileBox', self.domContext));
            }
            $('.cssTabContentBox', self.domContext).remove();
        },

        addMissingInfo: function(element, type) {
            const self = this;
            const _aInfoTextMap = {
                'lastSearches': 'Noch keine Vergleiche vorhanden',
                'nonContracts': 'Noch keine Aktivitäten vorhanden',
                'contracts': 'Keine Verträge vorhanden',
            };
            let _infoText = '';

            if (self && self.bShowContracts && type === 'lastSearches') {
                type = 'nonContracts';
            }

            if (_aInfoTextMap[type]) {
                _infoText = _aInfoTextMap[type];
            }

            element
                .prepend('<div class="missingInfo">' + _infoText + '</div>')
                .addClass('missingEntries');
        },

        showDefaultTeaser: function(self) {
            const showTeaserFunc = function() {
                if (self.$ac.hasClass('ipss')) {
                    self.$ac.removeClass(['ipss', 'ipssVor']);

                    self.$ac.find('.content').css({
                        'height': '',
                    });
                }

                if (self.isBlueTeaser) {
                    $('.greetingContainer', self.$ac).hide().remove();
                    $('.TeaserSubhead', self.$ac).removeClass('c24Hidden');
                    $('.subtext', self.$ac).fadeIn(300);
                } else if (self.sOriginalSubHead) {
                    $('.subhead', self.$ac).html(self.sOriginalSubHead);

                    $('.widgetWrapper', self.domContext).prev('.ipssHeadline').addClass('c24Hidden');
                }

                if (self.bIsMobile) {
                    $('.TeaserHeader', self.$ac).show();
                }

                $('header h3.original', self.$ac).show();
                $('.js24VsIpssDefaultTeaser', self.$ac).show();
                $('.box24VsIpssWrapper', self.domContext).addClass('c24Hidden');

                if (self.showStaticTile && self.bIsMobile) {
                    $('.staticTileContainer', self.domContext).addClass('c24Hidden');
                }

                $('.tmpCampaignLink', self.domContext).show();
                $('.c24Backgroundimage', self.domContext).show();
                $('.hideOnIpss', self.domContext).show();

                if ($('.mod24TeaserFading').length < 1) {
                    $('.mod24BlockLogin').show();
                }

            };

            if (self.$ac.hasClass('ipss') && self.bIsMobile && self.bUseTilesLayout) {
                let isTransitionEnded = false;
                self.$ac.one('transitionend', function(event) {
                    if (event.originalEvent.propertyName === 'opacity') {
                        isTransitionEnded = true;
                        showTeaserFunc();
                        self.$ac.removeClass('fadeIn').addClass('fadeOut');
                    }
                });
                self.$ac.removeClass('fadeOut').addClass('fadeIn');
                setTimeout(() => {
                    if (!isTransitionEnded) {
                        showTeaserFunc();
                        self.$ac.removeClass('fadeIn').addClass('fadeOut');
                    }
                }, 500);
            } else {
                showTeaserFunc();
            }
        },

        keepTeaserAppearance: function() {
            const self = this;

            self.$ac.removeClass('cdpImage');

            let ipssTeaserHeight = self.initialContextHeight || 0;
            let ipssContentMarginBottom = 0;


            const teaserImageDimensions = self.$ac.css('background-size').split(' ');

            if (typeof teaserImageDimensions[1] !== 'undefined' || typeof teaserImageDimensions[0] === 'undefined') {
                const positionYMultiplier = parseInt(self.initialBgImagePosition[1]) / 100;

                self.$ac.css({
                    'background-position': `${self.initialBgImagePosition[0]} ${ipssTeaserHeight - parseInt(teaserImageDimensions[1]) * positionYMultiplier}px`,
                });
            }

            if ($('.cssTabHeaderContainer', self.$ac).length > 0) {
                ipssTeaserHeight = ipssTeaserHeight - 48; // remove padding space
            } else {
                ipssTeaserHeight = ipssTeaserHeight - 45;
                ipssContentMarginBottom = 45;
            }

            if (ipssTeaserHeight > 0) {
                self.$ac.find('.content').css({
                    'height': ipssTeaserHeight,
                    'margin-bottom': ipssContentMarginBottom,
                });
            }
        },

        showIpssTeaser: function() {
            const self = this;
            const showTeaserFunc = function() {
                $('.box24VsIpssWrapper', self.domContext).hide().removeClass('c24Hidden').fadeIn();
                if (!self.$ac.hasClass('ipss')) {
                    self.$ac.addClass(['ipss', 'ipssVor']);

                    if (self.$ac.hasClass('ipssKeepLayout')) {
                        self.keepTeaserAppearance();
                    }
                }


                if (!self.$ac.hasClass('withStaticTile') && self.showStaticTile) {
                    if (!self.isStaticTileInFlow) {
                        self.$ac.addClass('withStaticTile');
                    }

                    if (self.bIsMobile) {
                        $('.staticTileContainer', self.domContext).hide().removeClass('c24Hidden').fadeIn();
                    }
                }

                if (self.bShowAllOnlyWhenFiltered) {
                    self.$ac.addClass('showAllOnlyWhenFiltered');
                }

                if (self.isBlueTeaser) {

                    if (!self.sOriginalSubHead) {
                        self.sOriginalSubHead = $('.TeaserSubhead', self.$ac).html();
                    }

                    if (!(self.bIsSeaPage && !self.bIsMobile)) {
                        $('.TeaserSubhead', self.$ac).addClass('c24Hidden');
                    }

                    if (self.bIsMobile) {
                        $('.TeaserHeader', self.$ac).hide();

                    }

                    if (self.showGreeting) {
                        let html = $('.js24VsIpssSubhead.teaserBlue', self.domContext).html();

                        $(self.$ac).append(`<div class="greetingContainer">${html}</div>`);

                        if (self.hideSubtextWhenIpssIsActive) {
                            $('.subtext', self.$ac).hide();
                        }
                    }

                    if (self.bIsMobile) {
                        const teaserLabels = $('.teaserLabel', self.domContext);

                        for (const teaserLabel of teaserLabels) {
                            $('.greetingContainer', self.domContext).append(teaserLabel);
                        }
                    }

                } else {

                    if (self.bIsMobile) {
                        $('.widgetWrapper', self.domContext).prev('.ipssHeadline').removeClass('c24Hidden');

                        if (self.showGreeting) {
                            $('header h3', self.$ac).addClass('original').hide();
                        }
                    }

                    let teaserLabelContent = '';

                    if (!self.sOriginalSubHead) {
                        self.sOriginalSubHead = $('header > .subhead', self.$ac).html();

                        if (self.showTeaserLabelInIpss) {
                            teaserLabelContent = $('header > .subhead .js24TeaserLabel', self.$ac).parent().html();
                        }
                    }

                    if (self.showGreeting) {
                        let html = $('.js24VsIpssSubhead:not(.teaserBlue)', self.domContext).html();

                        if (self.showTeaserLabelInIpss && teaserLabelContent) {
                            html += '<p>' + teaserLabelContent + '</p>';
                        }

                        $('header > .subhead', self.$ac).html(html);
                    }
                }

                if ($('.mod24TeaserFading').length < 1) {
                    $('.mod24BlockLogin').hide();
                }

                self.renderingDone.resolve();


                if (!window.location.hash) {
                    self.handleScrollDistance();
                }
            };

            self.renderingDone.promise();
            if (self.fadeTeaser) {
                if (!self.bUseTilesLayout) {
                    $('.js24VsIpssDefaultTeaser', this.domContext).stop().fadeOut(self.fadeTeaserDelay, showTeaserFunc);
                }
                $('.hideOnIpss, .c24Backgroundimage', this.domContext).stop().fadeOut(self.fadeTeaserDelay);

            } else {
                $('.js24VsIpssDefaultTeaser, .hideOnIpss, .c24Backgroundimage', this.domContext).hide();
            }

            if (!self.fadeTeaser || self.bUseTilesLayout) {

                const fadeInTeaser = () => {
                    showTeaserFunc();
                    if (self.bIsMobile) {
                        self.$ac.removeClass('fadeIn').addClass('fadeOut');
                    }
                };

                if (self.bIsMobile) {
                    let isTransitionEnded = false;
                    self.$ac.one('transitionend', function(event) {
                        if (event.originalEvent.propertyName === 'opacity') {
                            isTransitionEnded = true;
                            fadeInTeaser();
                        }
                    });
                    self.$ac.removeClass('fadeOut').addClass('fadeIn');
                    setTimeout(() => {
                        if (!isTransitionEnded) {
                            fadeInTeaser();
                        }
                    }, 500);
                } else {
                    fadeInTeaser();
                }
            }
            if (self.isWidgetPrefilledWithLastSearchData) {
                self.useLastSearchesLabelsAsFormData(self.prefilledLabels);
            }
        },

        handleScrollDistance: function() {
            const self = this;
            const ipssRect = self.domContext[0].getBoundingClientRect();
            const ipssHeight = ipssRect.height;

            const scrolledDistance = window.scrollY;

            if (scrolledDistance > self.initialContextBottom && ipssHeight != self.initialContextHeight) {
                const ipssOffset = ipssHeight - self.initialContextHeight;
                const currentScrollTop = scrolledDistance;
                const newScrollTop = currentScrollTop - ipssOffset;

                setTimeout(function() {
                    window.scrollTo(0, newScrollTop);
                }, 0);

            }
        },

        isLoadedFromCache: function() {
            if (window?.performance?.getEntriesByType) {
                const perfEntries = window.performance.getEntriesByType('navigation');

                if (perfEntries.length > 0 && perfEntries[0] && perfEntries[0].type === 'back_forward') {
                    return true;
                }
            }

            return false;
        },

        registerTabSwitchEvent: function() {
            const self = this;

            $('.cssTabHeaderContainer .cssTabHeaderItem', self.domContext).on('click', function() {
                const $self = $(this);

                self.selectTab($self);
            });
        },

        registerTilesFilterEvent() {
            const self = this;
            const $filterItems = $('.ipssFilterContainer .ipssFilterItem', self.domContext);

            $filterItems.on('click', e => {
                e.preventDefault();

                const $this = $(e.currentTarget);
                const filterType = $this.data('filter');

                if ($this.hasClass('active')) {
                    return false;
                }

                $filterItems.removeClass('active');
                $this.addClass('active');
                const $itemsWrapper = $('.ipssItemWrapper:not(.staticTileContainer, .staticTileInFlowContainer, .promotionsContainer, .consultantsContainer)', self.domContext);
                const $staticTileItems = $('.staticTileInFlowContainer', self.domContext).children('.staticTileBox');
                if (filterType === 'none') {
                    $staticTileItems.each((_, item) => {
                        $(item).removeClass('lastInFlow');
                    });
                } else {
                    $staticTileItems.each((_, item) => {
                        $(item).addClass('lastInFlow');
                    });
                }
                $itemsWrapper.each((_, wrapper) => {
                    let $wrapper = $(wrapper);
                    const $items = $wrapper.children('.ipssItem');

                    if (filterType === 'none') {

                        $items.fadeIn(0).promise().done(() => self.checkSliderArrowsVisibility());

                        if (self.bShowAllOnlyWhenFiltered) {
                            self.$ac.addClass('showAllOnlyWhenFiltered');

                            $items.css({
                                display: '',
                            });
                        }
                    } else {
                        if (self.bShowAllOnlyWhenFiltered) {
                            self.$ac.removeClass('showAllOnlyWhenFiltered');
                        }
                        const shouldBeVisible = $wrapper.hasClass(`${filterType}Container`);

                        $items.each((_, item) => {
                            $(item)[shouldBeVisible ? 'fadeIn' : 'fadeOut'](0).promise().done(() => self.checkSliderArrowsVisibility());

                            if (self.bShowAllOnlyWhenFiltered) {
                                $(item).css({
                                    display: shouldBeVisible ? '' : 'none',
                                });
                            }
                        });

                    }
                });
            });
        },

        showFilterChip: function(type, plural = false) {
            const self = this;
            let dataPrefix = '';
            let chipLabelSuffix = '';

            if (self.showFilterChips === false) {
                $('.ipssFilterContainer', self.domContext).hide();

                return;
            }

            if (type === 'offer' || type === 'incompleteContract') {
                dataPrefix = 's';
            }

            if (plural) {
                chipLabelSuffix = self.filterChipLabelMap[type].plural ?? '';
            } else {
                chipLabelSuffix = self.filterChipLabelMap[type].singular ?? '';
            }

            const chipLabel = `${chipLabelSuffix}`;

            if (!$(`.${type}Chip`, this.domContext).length) {
                if (!this.oClonedElementFilterChip) {
                    this.oElementTemplateFilterChip = $('.ipssFilterBox', this.domContext).clone();

                    $('.ipssFilterBox', this.domContext).remove();

                    this.oClonedElementFilterChip = true;
                }

                $('.ipssFilterItem.active', this.domContext).removeClass('active');

                this.oElementTemplateFilterChip.clone()
                    .addClass(`${type}Chip`)
                    .children('.ipssFilterItem')
                    .addClass('active')
                    .data('filter', type + dataPrefix)
                    .text(chipLabel)
                    .end()
                    .appendTo($('.ipssFilterContainer', this.domContext));

                if ($('.ipssFilterItem', this.domContext).length > 1) {
                    $('.ipssFilterItem.active', this.domContext).removeClass('active');

                    const showAllChipExists = $('.showAllChip', this.domContext).length > 0;
                    if (!showAllChipExists) {
                        this.oElementTemplateFilterChip.clone()
                            .addClass('showAllChip')
                            .children('.ipssFilterItem')
                            .data('filter', 'none')
                            .text(self.filterChipLabelMap.showAll)
                            .end()
                            .appendTo($('.ipssFilterContainer', this.domContext));
                    }

                    // Activate the showAllChip regardless of whether it's newly created or already exists.
                    $('.showAllChip .ipssFilterItem', this.domContext).addClass('active');
                }
            }
        },



        selectTab: function(tabHeaderItem) {
            const self = this;

            if (tabHeaderItem.hasClass('active')) {
                return;
            }

            $('.cssTabHeaderItem.active', self.domContext).removeClass('active');
            $('.cssTabContentBox.active', self.domContext).removeClass('active');

            tabHeaderItem.addClass('active');
            $('#' + tabHeaderItem.data('contentbox')).addClass('active');
        },

        registerReloadIpssEvent: function() {

            if (this.bReloadIpssEventRegistered) {
                return;
            }

            this.bReloadIpssEventRegistered = true;

            const self = this;

            $(window).on('pageshow', function(e) {

                if (!e.originalEvent?.persisted) {
                    return;
                }

                let isIpssVisible = false;

                const waitForIpssToBeVisible = () => {
                    if (isIpssVisible) {
                        return;
                    }

                    const ipssOffset = self.$ac.offset().top + self.$ac.outerHeight(false);
                    const scrollTop = $(window).scrollTop();

                    if (scrollTop < ipssOffset) {
                        isIpssVisible = true;
                        self.reload();
                    } else {
                        setTimeout(waitForIpssToBeVisible, 500);
                    }
                };

                waitForIpssToBeVisible();

            });
        },

        activateTracking: function() {
            const self = this;

            $('.box24VsIpss.js24VsIpss', this.domContext).on('c24IpssActive', function() {
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'active:ipss',
                    'ipss:' + self.sRenderType,
                ]);
            });

            $('.box24VsIpss', this.domContext).on('click c24Tracking', '.ipssItem .js24ButtonCompare', function() {
                const jSelf = $(this);
                const ipssItemCategory = jSelf.closest('.ipssItem').data('category');
                let actionName = '';
                let eventName = '';

                if (self.bIsMobile) {
                    if (ipssItemCategory === 'lastSearches') {
                        actionName = 'result';
                        eventName = 'result';
                    } else if (ipssItemCategory === 'offer') {
                        actionName = 'finish';
                        eventName = 'finish';
                    } else if (ipssItemCategory === 'incompleteContract') {
                        actionName = 'continue';
                        eventName = 'continue';
                    }
                } else {
                // tracking for primary button
                    if (jSelf.hasClass('primary')) {
                        if (ipssItemCategory === 'lastSearches') {
                            actionName = 'result';
                            eventName = 'result';
                        } else if (ipssItemCategory === 'offer') {
                            actionName = 'finish';
                            eventName = 'finish';
                        } else if (ipssItemCategory === 'incompleteContract') {
                            actionName = 'continue';
                            eventName = 'continue';
                        }
                    }

                    // tracking for secondary button
                    if (jSelf.hasClass('secondary')) {
                        if (ipssItemCategory === 'lastSearches') {
                            eventName = '';
                        } else if (ipssItemCategory === 'offer') {
                            actionName = 'offerDetails';
                            eventName = 'details';
                        } else if (ipssItemCategory === 'incompleteContract') {
                            actionName = 'offerDetails';
                            eventName = 'details';
                        }
                    }
                }

                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'cta:' + actionName,
                    ipssItemCategory + ':' + eventName,
                ]);
            });

            // for ipss v2 not needed
            $('.box24VsIpss.ipssNewCompareContainer', this.domContext).on('click', '.c24Button', function() {
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'cta:ipss',
                    'cta:newcompare',
                ]);
            });

            if (self.bIsMobile) {
                $('.box24VsIpss', this.domContext).on('c24IpssDelete', '.metaData', function() {
                    const jSelf = $(this);
                    const ipssItemCategory = jSelf.closest('.ipssItem').data('category');

                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'cta:delete',
                        'delete:' + ipssItemCategory,
                    ]);
                });

            } else {
                $('.box24VsIpss', this.domContext).on('c24IpssDelete', '.delete', function() {
                    const jSelf = $(this);
                    const ipssItemCategory = jSelf.closest('.ipssItem').data('category');

                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'cta:delete',
                        'delete:' + ipssItemCategory,
                    ]);
                });
            }
        },

        spinnerEvent: function() {
            $('.box24VsIpss', this.domContext).on('click c24Spinner', '.ipssItem .js24LoadingToggle', function() {
                let oElement = $(this).find('.js24LoadingAction');

                if (!oElement.length) {
                    $(this).append('<span class="js24LoadingAction"></span>');
                    oElement = $(this).find('.js24LoadingAction');
                }

                oElement.addClass('is-loading');

                setTimeout(function() {
                    oElement.removeClass('is-loading');
                }, 8000);

                return false;
            });
        },

        handleDeleteAllLinks: function() {
            const self = this;
            const oDeleteAll = self.aApiDataResult?.deleteAll;

            for (let sType in self.deleleAllTextMap) {
                if (oDeleteAll === undefined || oDeleteAll[sType] === undefined) {
                    continue;
                }

                let iAmount = 0;
                let sDeleteText = '';

                if (sType === 'lastSearches') {
                    iAmount = self?.aNonContractsGrouped?.lastSearches?.length ?? 0;
                } else if (sType === 'offer') {
                    iAmount = self?.aNonContractsGrouped?.contracts.filter(entry => entry.type === sType)?.length ?? 0;
                } else if (sType === 'incompleteContract') {
                    iAmount = self?.aNonContractsGrouped?.contracts.filter(entry => entry.type === sType)?.length ?? 0;
                } else if (sType === 'contract') {
                    iAmount = self.aContractsGrouped?.length ?? 0;
                }

                if (iAmount === 0) {
                    continue;
                }

                if (iAmount > 1) {
                    sDeleteText = self.deleleAllTextMap[sType].plural;
                } else {
                    sDeleteText = self.deleleAllTextMap[sType].singular;
                }

                sDeleteText += ' löschen';

                let sDeleteAllUrl = undefined;

                switch (self.getDeviceType(self)) {
                    case 'app':
                        sDeleteAllUrl = oDeleteAll[sType]?.urlApp ?? oDeleteAll[sType]?.urlMobile;
                        break;
                    case 'tabletApp':
                        sDeleteAllUrl = oDeleteAll[sType]?.urlTabletApp ?? oDeleteAll[sType]?.urlDesktop;
                        break;
                    case 'mobile':
                        sDeleteAllUrl = oDeleteAll[sType]?.urlMobile;
                        break;
                    case 'desktop':
                        sDeleteAllUrl = oDeleteAll[sType]?.urlDesktop;
                        break;
                }

                if (sDeleteAllUrl !== undefined) {
                    const $deleteElement = document.createElement('a');

                    $deleteElement.className = 'deleteAll ' + sType;
                    $deleteElement.innerText = sDeleteText;

                    $deleteElement.dataset.deletelink = sDeleteAllUrl;
                    $deleteElement.dataset.category = sType;

                    $($deleteElement).on('click', function(e) {
                        e.preventDefault();
                        self.removeIpssItem($(this), self, true);
                    });

                    $('.ipssItem.' + sType, self.domContext).closest('.ipssItemWrapper').append($($deleteElement));
                }
            }
        },

        handleUserData: function() {
            const self = this;
            const aUserData = self.aApiDataResult.userData;

            let aTeaserImageUrls = [];
            let categoryToUse = null;

            if (!aUserData) {
                return false;
            }

            if (aUserData.userPreferences) {
                aTeaserImageUrls = self.getTeaserImagesUrls(aUserData.userPreferences, self);
            }

            for (const sCategory in aTeaserImageUrls) {
                if (self.isValidUrl(aTeaserImageUrls[sCategory].urlTeaserImage)) {
                    categoryToUse = sCategory;

                    break;
                }
            }

            if (!categoryToUse) {
                return;
            }

            const aColors = aUserData.userPreferences[categoryToUse].backgroundColor || [];

            self.$ac.addClass('cdpImage');

            self.$ac.css({
                '--cdpImage': 'url(\'' + aTeaserImageUrls[categoryToUse].urlTeaserImage + '\')',
            });

            if (Object.keys(aColors).length > 0) {

                let sTeaserBgColor = undefined;

                switch (self.getDeviceType(self)) {
                    case 'app':
                        if (aColors.backgroundColorApp) {
                            sTeaserBgColor = aColors.backgroundColorApp;
                        } else {
                            sTeaserBgColor = aColors.backgroundColorMobile;
                        }
                        break;
                    case 'tabletApp':
                        if (aColors.backgroundColorTabletApp) {
                            sTeaserBgColor = aColors.backgroundColorTabletApp;
                        } else {
                            sTeaserBgColor = aColors.backgroundColorDesktop;
                        }
                        break;
                    case 'mobile':
                        sTeaserBgColor = aColors.backgroundColorMobile;
                        break;
                    case 'desktop':
                        sTeaserBgColor = aColors.backgroundColorDesktop;
                        break;
                }

                self.$ac.css({
                    '--cdpBackgroundColor': sTeaserBgColor,
                });
            }
        },

        getTeaserImagesUrls: function(aUserPreferences, self) {
            const aUrlCollecttion = [];

            for (let sCategory in aUserPreferences) {
                let aImages = aUserPreferences[sCategory].backgroundImage;
                let sTeaserUrl = '';

                switch (self.getDeviceType(self)) {
                    case 'app':
                        if (aImages.urlApp) {
                            sTeaserUrl = aImages.urlApp;
                        } else {
                            sTeaserUrl = aImages.urlMobile;
                        }
                        break;
                    case 'tabletApp':
                        if (aImages.urlTabletApp) {
                            sTeaserUrl = aImages.urlTabletApp;
                        } else {
                            sTeaserUrl = aImages.urlDesktop;
                        }
                        break;
                    case 'mobile':
                        sTeaserUrl = aImages.urlMobile;
                        break;
                    case 'desktop':
                        sTeaserUrl = aImages.urlDesktop;
                        break;
                }

                aUrlCollecttion[sCategory] = {
                    'urlTeaserImage': sTeaserUrl,
                };
            }

            return aUrlCollecttion;
        },

        getDeviceType: function(self) {
            if (self.bIsApp) {
                return self.bIsMobile ? 'app' : 'tabletApp';
            }

            return self.bIsMobile ? 'mobile' : 'desktop';
        },

        isValidUrl: function (sUrl) {
            let oUrl;

            try {
                oUrl = new URL(sUrl);
            } catch (_) {
                return false;
            }

            return oUrl.protocol === 'https:';
        },

        determineStaticTilePosition: function(sortedLis) {
            const self = this;
            const styles = window.getComputedStyle(self.domContext[0]);


            const tilesMarginX = styles.getPropertyValue('--tilesMarginX') || '10px';
            const tilesWidth = styles.getPropertyValue('--tilesWidth') || '298px';
            const tilesGap = styles.getPropertyValue('--tilesGap') || '20px';
            const viewportWidth = $(window).width();

            const itemWidth = parseInt(tilesMarginX, 10) * 2 + parseInt(tilesWidth, 10) + parseInt(tilesGap, 10);
            const categories = new Set();


            for (const child of sortedLis) {
                const classList = $(child).attr('class').split(/\s+/);
                const category = classList[classList.length - 1];
                categories.add(category);
            }

            const staticTilesIndex = self.tilesOrder.indexOf('staticTiles');
            if (staticTilesIndex > -1) {
                self.staticTilePosition = undefined;
                return self.staticTilePosition;
            }
            if (categories.size === 1 && categories.has('crossSelling')) {
                self.staticTilePosition = 0;
                return 0;
            }
            if (typeof self.staticTilePosition === 'undefined') {
                4 * itemWidth < viewportWidth ? self.staticTilePosition = 3 : self.staticTilePosition = 2;
            }
            self.staticTilePosition = Math.min(sortedLis.length, Math.min(self.staticTilePosition, 3));

            return self.staticTilePosition;
        },
        getMostRecentDate: function(date1, date2) {

            return date1 > date2 ? date1 : date2;
        },
        getLastSearchesLabelsForPrefilledForm: function(data) {
            const self = this;
            const dataInputs = data.result.inputs;
            Object.entries(self.prefilledLabelsKeys).forEach(([key, value]) => {
                if (dataInputs && dataInputs[value]) {
                    const newValue = dataInputs[value];
                    const label = self.prefilledLabels[key];
                    if (label) {
                        const mostRecentDate = self.getMostRecentDate(label.date, data.time);
                        if (mostRecentDate === data.time) {
                            self.prefilledLabels[key].value = newValue;
                            self.prefilledLabels[key].date = data.time;

                        }
                    } else {
                        self.prefilledLabels[key] = {
                            value: newValue,
                            date: data.time,
                        };
                    }
                }
            });

        },
        useLastSearchesLabelsAsFormData: function(lastSearchesLabels) {
            const self = this;
            const labels = Object.entries(lastSearchesLabels);
            labels.map(([key, value]) => {
                const valueToUse = value.value.toString();
                if (!valueToUse) {
                    return;
                }

                const formField = self.$ac.find(`[name="${key}"]`);
                const formFieldTag = formField.prop('tagName');
                if (formFieldTag === 'INPUT') {
                    for (const field of formField) {
                        const eventValues = {};
                        const isFieldRadioOrCheckbox = field.type === 'radio' || field.type === 'checkbox';
                        if (isFieldRadioOrCheckbox) {
                            field.checked = field.value.toLowerCase() === valueToUse.toLowerCase();
                        } else {
                            field.value = valueToUse;
                            eventValues.data = valueToUse;
                            eventValues.inputType = 'insertText';
                            eventValues.isComposing = false;
                            eventValues.dataTransfer = null;
                        }
                        const event = new Event('input', {
                            bubbles: true,
                            ...eventValues,
                        });
                        field.dispatchEvent(event);
                    }
                } else if (formFieldTag === 'SELECT') {
                    formField.find(`option[value="${valueToUse}"]`).prop('selected', true);
                }
            });

        },

    };
})();
